import React, { useEffect, useRef, useState } from "react";
import Left_panel from "../Left_panel";
import Sub_header from "../Sub_header";
import axios from "axios";
import exportValue from "../../apiconfig";
import Swal from "sweetalert2";
import Modal from "react-bootstrap/Modal";
import ReactLoading from "react-loading";
import Moment from "react-moment";
import "../../components/loader.css";
import TablePagination from "@mui/material/TablePagination";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  ProgressBar,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import download from "downloadjs";
import { DateRangePicker } from "react-date-range";
import { addDays } from "date-fns";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";
import Call from "../call";
import useCallManager from "../CallManager";

import moment from "moment";

const Ndr_shipments = () => {
  let navigate = useNavigate();
  let admindata = {};
  if (localStorage.getItem("admin_login")) {
    admindata = JSON.parse(localStorage.getItem("admin_login"));
    console.log("admindata------>  -  ", admindata);
  }
  const [state, setState] = React.useState({
    shipmnent_list: [],
    dataCount: 0,
    isLoading: true,
    dialogOpen: false,
    searchValue: "",
    count_all: 0,
    count_action_required: 0,
    count_action_requested: 0,
    count_delivered: 0,
    count_rto: 0,
    count_pending: 0,
    count_ofd: 0,
  });
  const inputRef = useRef(null);
  const search = window.location.search;
  // console.log("search -   ",search);
  const params = new URLSearchParams(search);
  const pendingOrder = params.get("type");
  console.log("pendingOrder == ", pendingOrder);
  let title = params.get("title");
  let juu = search.split("?status=");
  // console.log("params 00  -- - -  - - -  ",juu)
  let shipmetFilterUrl = [];
  if (juu[1]) {
    // console.log("params  -- - -  - - -  ",juu[1].split('%26'))
    shipmetFilterUrl = juu[1].split("%26");
  }
  //let status = params.get('status');
  //console.log("status====",status)
  const [selectedResponse, setSelectedResponse] = useState(""); // Selected predefined response
  const [replyText, setReplyText] = useState(""); // Reply text
  const [mp3File, setMp3File] = useState(null);
  const [callRecordings, setCallRecordings] = useState([]);
  const [ndrloader, setndrloader] = React.useState(false);
  const [viewModal, setviewModal] = React.useState({ show: false, sub: {} });
  // const [shipmentstate, setshipStatus] = React.useState({ status: 0 });
  const [modals, setModals] = React.useState({ show: false, invoice_id: "" });
  const [otherStates, setOtherState] = React.useState({
    activePage: 1,
    rowsPerPage: 100,
    page: 0,
    total_count: 0,
    onload: true,
  });
  const [statusfilters, setstatusFilters] = React.useState({
    current_status: shipmetFilterUrl,
  });
  const [searchfilters, setsearchFilters] = React.useState({
    searchtitle: "",
    filter: [
      { name: "booked", value: 1, status: true },
      { name: "assigned", value: 2, status: true },
      { name: "intransit", value: 3, status: true },
      { name: "delivered", value: 4, status: true },
    ],
    filterStatus: [],
  });
  console.log("filter_status ==", searchfilters);
  const [date, setdate] = React.useState({
    from_date: moment().subtract(30, "days").format("YYYY-MM-DD"),
    to_date: moment().format("YYYY-MM-DD"),
  });
  const [shipmentstate, setshipStatus] = React.useState({
    shipment_status: null,
  });
  // const [searchfilters, setsearchFilters] = React.useState({ filterStatus:[]})
  const [dimensionState, setdimensionState] = React.useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [setDate, setDateState] = useState({ date: "" });
  const [stateship, setStateship] = React.useState({
    shipmentDetail: { sender: {}, receiver: {}, items: [] },
    isLoading: true,
    detailFound: false,
    parcel_count: 0,
    customer_detail: {},
  });
  const [focusedIndex, setfocusedIndex] = React.useState(-1);
  const [searchwithstate, setsearchwithstate] = React.useState({
    search_with: "order",
  });
  const [searchshipment, setsearchshipment] = React.useState({
    shipment_id: "",
  });
  const [stateshipment, setShipments] = React.useState({ shipment: {} });
  const [ndrstate, setndrstate] = React.useState({
    ndr_date: "",
    ndr_address: "",
    ndr_phone: "",
    ndr_remarks: "",
  });
  const [history, sethistory] = React.useState({ ndr_history: [], awb: "" });
  const [showNDRModal, setShowNDRModal] = useState(false);
  const [typestate, setType] = React.useState({ type: 5 });
  const [ndrmodal, setndrmodal] = React.useState(false);
  const [selectedRecordings, setSelectedRecordings] = useState([]);
  const [imageFile, setImageFile] = useState(null);
  const [replySubmitted, setReplySubmitted] = useState(false);
  const [adminstate, setadminstate] = useState({ user_id: "", password: "" });
  const [showEditConsignee, setShowEditConsignee] = useState(false);
  const [selectedConsigneeField, setSelectedConsigneeField] = useState("");
  const [searchstate, setsearchstate] = React.useState({ search_shipment: "" });
  const [editedConsignee, setEditedConsignee] = useState({
    name: "",
    address: "",
    mobile: "",
    payment_mode: "",
    cod_amount: "",
  });
  const [openOffdetailcanvas, setOpenOffdetailcanvas] = React.useState(false);
  const [bookorder, setbookorder] = React.useState([]);
  const [reattemptLoaderId, setReattemptLoaderId] = React.useState(null);
  const [rtoloaderId, setrtoloaderId] = React.useState(null);
  const [isUpdatingConsignee, setIsUpdatingConsignee] = useState(false);
  const [trackingstate, setTrackingState] = React.useState({
    track: {},
    isLoading: true,
  });
  const [rtoShield, setRtoShield] = useState("ON");
  console.log("rtoShield === ", rtoShield);
  const [communicationHistory, setCommunicationHistory] = React.useState([]);
  const [datestate, setdateState] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 0),
      key: "selection",
      isOpen: false,
    },
  ]);
  var months = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  var days = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
  ];

  const xcc =
    datestate[0].startDate.getFullYear() +
    "-" +
    months[datestate[0].startDate.getMonth()] +
    "-" +
    days[datestate[0].startDate.getDate()];
  const ycc =
    datestate[0].endDate.getFullYear() +
    "-" +
    months[datestate[0].endDate.getMonth()] +
    "-" +
    days[datestate[0].endDate.getDate()];
  const [rstate, setRState] = useState({
    suggestions: [],
    text: "",
  });
  const [customeridstate, setcustomeridstate] = React.useState({
    customer_id: "",
  });
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const [selectedShipments, setSelectedShipments] = React.useState([]);
  // console.log("selectedShipments === " ,selectedShipments)
  const [selectCount, setSelectCount] = React.useState({ select_count: 0 });
  const {
    shipperCall,
    consigneeCall,
    isInitialized,
    loginError,
    initPIOPIY,
    makeCall,
    endCall,
  } = useCallManager();

  // Initialize PIOPIY when modal opens
  useEffect(() => {
    const PIOPIY_USER_ID = adminstate.user_id;
    const PIOPIY_PASSWORD = adminstate.password;
    initPIOPIY(PIOPIY_USER_ID, PIOPIY_PASSWORD);

    if (viewModal.sub.shipment_id) {
      loadCallRecordings(viewModal.sub.shipment_id);
    }

    return () => {
      // Cleanup handled by hook
    };
  }, [viewModal.sub.shipment_id]);

  const handleCallShipper = () => {
    if (viewModal.sub.sender && viewModal.sub.sender[0].mobile) {
      makeCall(viewModal.sub.sender[0].mobile, "shipper");
    }
  };

  const handleCallConsignee = () => {
    if (viewModal.sub.receiver && viewModal.sub.receiver[0].mobile) {
      makeCall(viewModal.sub.receiver[0].mobile, "consignee");
    }
  };

  const loadCallRecordings = async (shipmentId) => {
    try {
      const response = await axios.post(
        `${exportValue.host}/${exportValue.version}/${exportValue.api}/get_call_recordings`,
        { shipment_id: shipmentId }
      );

      if (response.data.success) {
        setCallRecordings(response.data.recordings || []);
        setIsLoading(false);
      } else {
        console.error("API Error:", response.data.message);
        setCallRecordings([]);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error loading call recordings:", error);
      setCallRecordings([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (viewModal.show && viewModal.sub.receiver) {
      setEditedConsignee({
        name: viewModal.sub.receiver[0].name,
        address: viewModal.sub.receiver[0].address,
        mobile: viewModal.sub.receiver[0].mobile,
        payment_mode: viewModal.sub.payment_mode || "",
        cod_amount: viewModal.sub.cod_amount || "",
      });
    }
  }, [viewModal.show, viewModal.sub.receiver]);

  const handleConsigneeUpdate = async () => {
    if (!selectedConsigneeField || !editedConsignee[selectedConsigneeField]) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please select a field and enter a value",
      });
      return;
    }

    let actualPaymentMode = editedConsignee.payment_mode;
    let requiresCodAmount = false;

    if (
      selectedConsigneeField === "payment_mode" &&
      editedConsignee.payment_mode === "prepaid"
    ) {
      actualPaymentMode = "cod";
      requiresCodAmount = true;
    } else if (
      selectedConsigneeField === "payment_mode" &&
      editedConsignee.payment_mode === "cod"
    ) {
      actualPaymentMode = "prepaid";
      requiresCodAmount = false;
    }

    if (requiresCodAmount && !editedConsignee.cod_amount) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter COD amount when selecting COD payment mode",
      });
      return;
    }

    setIsUpdatingConsignee(true);

    try {
      const payload = {
        shipment: viewModal.sub,
        field: selectedConsigneeField,
        value:
          selectedConsigneeField === "payment_mode"
            ? actualPaymentMode
            : editedConsignee[selectedConsigneeField],
      };

      if (selectedConsigneeField === "payment_mode") {
        payload = {
          ...payload,
          payment_mode: actualPaymentMode,
          cod_amount:
            actualPaymentMode === "cod" ? editedConsignee.cod_amount : null,
        };
      }

      const response = await axios.post(
        `${exportValue.host}/${exportValue.version}/${exportValue.api}/update_consignee`,
        payload,
        { headers: exportValue.headers }
      );
      console.log("response ==", response);
      if (response.data.success) {
        // Update local state
        const updatedSub = {
          ...viewModal.sub,
          receiver: [
            {
              ...viewModal.sub.receiver[0],
              [selectedConsigneeField]:
                selectedConsigneeField === "payment_mode"
                  ? actualPaymentMode
                  : editedConsignee[selectedConsigneeField],
            },
          ],
          payment_mode: actualPaymentMode,
          cod_amount:
            actualPaymentMode === "cod" ? editedConsignee.cod_amount : null,
        };

        setviewModal({ ...viewModal, sub: updatedSub });
        setSelectedConsigneeField("");
        setShowEditConsignee(false);
        // toast.success("Consignee details updated successfully!");
        Swal.fire({
          icon: "success",
          title: "Good job...",
          text: "Consignee details updated successfully!",
        });
      } else {
        // toast.error(response.data.message || "Failed to update consignee details");
        Swal.fire({
          icon: "error",
          title: "Oops..",
          text: response.data.message || "Failed to update consignee details",
        });
      }
    } catch (error) {
      console.error("Error updating consignee:", error);
      Swal.fire({
        icon: "error",
        title: "Oops..",
        text:
          error.response.data.message ||
          "An error occurred while updating consignee details",
      });
      // toast.error("An error occurred while updating consignee details");
    } finally {
      setIsUpdatingConsignee(false);
    }
  };

  const adminDetail = () => {
    let full_api =
      exportValue.host +
      "/" +
      exportValue.version +
      "/" +
      exportValue.api +
      `/admin_detail`;
    let sendData = { admin_id: admindata.admin_id };
    console.log("bb", sendData);
    axios
      .post(full_api, sendData, { headers: exportValue.headers })
      .then((res) => {
        console.log("res -> ", res);
        setadminstate({
          ...adminstate,
          user_id: res.data.output[0].tel_user_id
            ? res.data.output[0].tel_user_id
            : "",
          password: res.data.output[0].tel_password
            ? res.data.output[0].tel_password
            : "",
        });
      })
      .catch((e) => {
        console.log("----error:   ", e);
      });
  };

  // Helper function to format phone numbers
  const formatPhoneNumber = (number) => {
    // Remove all non-digit characters
    const cleaned = number.replace(/\D/g, "");

    // If number starts with country code, return as is
    if (cleaned.length > 10) {
      return cleaned;
    }

    // Otherwise, assume it's Indian number and add 91 prefix
    return `91${cleaned}`;
  };

  // Handle call ended (save recording)
  // useEffect(() => {
  //   console.log("shipperCall.status == ", shipperCall.status);

  //   if (shipperCall.status === 'ended' && shipperCall.callId) {
  //     setIsLoading(true);

  //     const timer = setTimeout(() => {
  //       saveCallRecording(
  //         viewModal.sub.shipment_id,
  //         shipperCall.callId,
  //         shipperCall.duration,
  //         viewModal.sub.sender[0].mobile
  //       );
  //     }, 5000); // 5 seconds

  //     // Cleanup timeout if the component unmounts or dependencies change
  //     return () => clearTimeout(timer);
  //   }
  // }, [shipperCall.status]);

  // Handle consignee call ended
  useEffect(() => {
    console.log("consigneeCall.status == ", consigneeCall.status);
    console.log("consigneeCall.callId == ", consigneeCall.callId);

    if (consigneeCall.status === "ended" && consigneeCall.callId) {
      setIsLoading(true);
      const timer = setTimeout(() => {
        saveCallRecording(
          viewModal.sub.shipment_id,
          consigneeCall.callId,
          consigneeCall.duration,
          viewModal.sub.receiver[0].mobile
        );
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [consigneeCall.status]);

  const saveCallRecording = async (
    shipmentId,
    callId,
    duration,
    phoneNumber
  ) => {
    try {
      const formattedNumber = formatPhoneNumber(phoneNumber);
      const response = await axios.post(
        `${exportValue.host}/${exportValue.version}/${exportValue.api}/save_call_recording`,
        {
          shipment_id: shipmentId,
          call_id: callId,
          phone_number: formattedNumber,
          duration: duration,
          timestamp: new Date().toISOString(),
        }
      );

      if (response.success == true) {
        // Recording available immediately
        loadCallRecordings(viewModal.sub.shipment_id);
      } else {
        // Poll for recording or wait for push notification
        setTimeout(() => {
          loadCallRecordings(viewModal.sub.shipment_id);
        }, 5000);
      }
    } catch (error) {
      console.error("Error saving call recording:", error);
      throw error;
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector(".home-section");
    if (homeSection) {
      homeSection.classList.toggle("sidebar-closed");
    }
  };
  // const dimension_detail = () =>{
  //     let full_api = exportValue.host + '/' + exportValue.version + '/' + exportValue.api + `/company_info_api`;
  //     let sendData = {};

  //     axios.post(full_api, sendData, { headers: exportValue.headers }).then(res => {
  //       setdimensionState({...dimensionState,companyDetail:res.data.companyDetail});
  //       console.log("rnmmmmm", res);
  //     }).catch((e) => {
  //       // toast.configure()
  //        //toast.error("Some thing went wrong")
  //       console.log("----error:   ", e);
  //     })
  //   }
  useEffect(() => {
    //   axios_get_api()
    customerProfile();
    adminDetail();
  }, []);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    console.log("urlSearchParams == ", urlSearchParams);
    // Get and set the customer_id from the URL
    const urlCustomerID = urlSearchParams.get("customer_id");
    const urlStatus = urlSearchParams.get("status");
    console.log("urlStatus == ", urlStatus);
    const decodedStatus = decodeURIComponent(urlStatus);
    const statusArray = decodedStatus.split(",");
    const statusNumbers = statusArray.map(Number);
    console.log("statusNumbers == ", statusNumbers);
    const order_number = urlSearchParams.get("number");

    if (urlCustomerID && !urlStatus && !order_number) {
      console.log("Customer ID:", urlCustomerID);
      let full_api1 =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/customer_id_profile`;
      let sendData1 = { customer_id: urlCustomerID };

      axios
        .post(full_api1, sendData1, { headers: exportValue.headers })
        .then((res) => {
          // setdimensionState(res.data.output);
          setRState({ ...rstate, text: res.data.output[0].full_name });
          setcustomeridstate({
            ...customeridstate,
            customer_id: res.data.output[0].customer_id,
          });
          console.log("rnmmmmm", res);
        })
        .catch((e) => {
          // toast.configure()
          //toast.error("Some thing went wrong")
          console.log("----error:   ", e);
        });
      //   console.log("onLoad--->",onLoad)
      let onLoad = true;
      let index = 0;
      setIsLoading(true);
      let full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/shipment_list`;
      let sendData = {
        find: "",
        // shipment_status: shipment_status,
        indexValue: index,
        limit: otherStates.rowsPerPage,
        customer_id: urlCustomerID,
        date: "",
      };
      console.log("sendData", sendData);

      console.log("send", sendData);
      axios
        .post(full_api, sendData, { headers: exportValue.headers })
        .then((res) => {
          setIsLoading(false);
          if (index == 0 && onLoad) {
            setOtherState({
              ...otherStates,
              total_count: res.data.dataCount,
              page: index,
            });
          }

          setState({
            ...state,
            shipmnent_list: res.data.output,
            dataCount: res.data.dataCount,
            isLoading: false,
          });
        })
        .catch((e) => {
          setIsLoading(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          console.log("----error:   ", e);
        });
    } else if (
      !urlCustomerID &&
      !order_number &&
      urlStatus &&
      statusNumbers.length > 0
    ) {
      let onLoad = true;
      let index = 0;
      setIsLoading(true);
      let full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/shipment_list`;
      let sendData = {
        find: "",
        // shipment_status: shipment_status,
        indexValue: index,
        limit: otherStates.rowsPerPage,
        customer_id: "",
        date: "",
      };
      console.log("sendData", sendData);

      sendData.status = statusNumbers;

      console.log("send", sendData);
      axios
        .post(full_api, sendData, { headers: exportValue.headers })
        .then((res) => {
          setIsLoading(false);
          if (index == 0 && onLoad) {
            setOtherState({
              ...otherStates,
              total_count: res.data.dataCount,
              page: index,
            });
          }

          setState({
            ...state,
            shipmnent_list: res.data.output,
            dataCount: res.data.dataCount,
            isLoading: false,
          });
        })
        .catch((e) => {
          setIsLoading(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          console.log("----error:   ", e);
        });
    } else if (order_number && !urlCustomerID && !urlStatus) {
      setsearchshipment({ shipment_id: order_number });
      let onLoad = true;
      let index = 0;
      setIsLoading(true);
      let full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/shipment_list`;
      let sendData = {
        find: "",
        // shipment_status: shipment_status,
        indexValue: index,
        limit: otherStates.rowsPerPage,
        customer_id: "",
        date: "",
        search_with: searchwithstate.search_with,
      };
      console.log("sendData", sendData);
      sendData.find = order_number;

      console.log("send", sendData);
      axios
        .post(full_api, sendData, { headers: exportValue.headers })
        .then((res) => {
          setIsLoading(false);
          if (index == 0 && onLoad) {
            setOtherState({
              ...otherStates,
              total_count: res.data.dataCount,
              page: index,
            });
          }

          setState({
            ...state,
            shipmnent_list: res.data.output,
            dataCount: res.data.dataCount,
            isLoading: false,
          });
        })
        .catch((e) => {
          setIsLoading(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          console.log("----error:   ", e);
        });
    } else if (
      urlCustomerID &&
      urlStatus &&
      statusNumbers.length > 0 &&
      !order_number
    ) {
      console.log("Customer ID:", urlCustomerID);
      let full_api1 =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/customer_id_profile`;
      let sendData1 = { customer_id: urlCustomerID };

      axios
        .post(full_api1, sendData1, { headers: exportValue.headers })
        .then((res) => {
          // setdimensionState(res.data.output);
          setRState({ ...rstate, text: res.data.output[0].full_name });
          setcustomeridstate({
            ...customeridstate,
            customer_id: res.data.output[0].customer_id,
          });
          console.log("rnmmmmm", res);
        })
        .catch((e) => {
          // toast.configure()
          //toast.error("Some thing went wrong")
          console.log("----error:   ", e);
        });
      let onLoad = true;
      let index = 0;
      setIsLoading(true);
      let full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/shipment_list`;
      let sendData = {
        find: "",
        // shipment_status: shipment_status,
        indexValue: index,
        limit: otherStates.rowsPerPage,
        customer_id: urlCustomerID,
        date: "",
      };
      console.log("sendData", sendData);

      if (searchfilters.searchtitle != "") {
        sendData.find = searchfilters.searchtitle;
      }
      // if(searchfilters.filterStatus.length > 0) {
      sendData.status = statusNumbers;
      // }
      console.log("send", sendData);
      axios
        .post(full_api, sendData, { headers: exportValue.headers })
        .then((res) => {
          setIsLoading(false);
          if (index == 0 && onLoad) {
            setOtherState({
              ...otherStates,
              total_count: res.data.dataCount,
              page: index,
            });
          }

          setState({
            ...state,
            shipmnent_list: res.data.output,
            dataCount: res.data.dataCount,
            isLoading: false,
          });
        })
        .catch((e) => {
          setIsLoading(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          console.log("----error:   ", e);
        });
    } else if (urlCustomerID && !urlStatus && order_number) {
      console.log("Customer ID:", urlCustomerID);
      let full_api1 =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/customer_id_profile`;
      let sendData1 = { customer_id: urlCustomerID };

      axios
        .post(full_api1, sendData1, { headers: exportValue.headers })
        .then((res) => {
          // setdimensionState(res.data.output);
          setRState({ ...rstate, text: res.data.output[0].full_name });
          setcustomeridstate({
            ...customeridstate,
            customer_id: res.data.output[0].customer_id,
          });
          console.log("rnmmmmm", res);
        })
        .catch((e) => {
          // toast.configure()
          //toast.error("Some thing went wrong")
          console.log("----error:   ", e);
        });
      let onLoad = true;
      let index = 0;
      setIsLoading(true);
      let full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/shipment_list`;
      let sendData = {
        find: "",
        // shipment_status: shipment_status,
        indexValue: index,
        limit: otherStates.rowsPerPage,
        customer_id: urlCustomerID,
        date: "",
        search_with: searchwithstate.search_with,
      };
      console.log("sendData", sendData);
      sendData.find = order_number;

      console.log("send", sendData);
      axios
        .post(full_api, sendData, { headers: exportValue.headers })
        .then((res) => {
          setIsLoading(false);
          if (index == 0 && onLoad) {
            setOtherState({
              ...otherStates,
              total_count: res.data.dataCount,
              page: index,
            });
          }

          setState({
            ...state,
            shipmnent_list: res.data.output,
            dataCount: res.data.dataCount,
            isLoading: false,
          });
        })
        .catch((e) => {
          setIsLoading(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          console.log("----error:   ", e);
        });
    } else if (
      !urlCustomerID &&
      urlStatus &&
      statusNumbers.length > 0 &&
      order_number
    ) {
      let onLoad = true;
      let index = 0;
      setIsLoading(true);
      let full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/shipment_list`;
      let sendData = {
        find: "",
        // shipment_status: shipment_status,
        indexValue: index,
        limit: otherStates.rowsPerPage,
        customer_id: "",
        date: "",
        search_with: searchwithstate.search_with,
      };
      console.log("sendData", sendData);
      sendData.find = order_number;
      sendData.status = statusNumbers;

      console.log("send", sendData);
      axios
        .post(full_api, sendData, { headers: exportValue.headers })
        .then((res) => {
          setIsLoading(false);
          if (index == 0 && onLoad) {
            setOtherState({
              ...otherStates,
              total_count: res.data.dataCount,
              page: index,
            });
          }

          setState({
            ...state,
            shipmnent_list: res.data.output,
            dataCount: res.data.dataCount,
            isLoading: false,
          });
        })
        .catch((e) => {
          setIsLoading(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          console.log("----error:   ", e);
        });
    } else if (
      urlCustomerID &&
      urlStatus &&
      statusNumbers.length > 0 &&
      order_number
    ) {
      console.log("Customer ID:", urlCustomerID);
      let full_api1 =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/customer_id_profile`;
      let sendData1 = { customer_id: urlCustomerID };

      axios
        .post(full_api1, sendData1, { headers: exportValue.headers })
        .then((res) => {
          // setdimensionState(res.data.output);
          setRState({ ...rstate, text: res.data.output[0].full_name });
          setcustomeridstate({
            ...customeridstate,
            customer_id: res.data.output[0].customer_id,
          });
          console.log("rnmmmmm", res);
        })
        .catch((e) => {
          // toast.configure()
          //toast.error("Some thing went wrong")
          console.log("----error:   ", e);
        });
      let onLoad = true;
      let index = 0;
      setIsLoading(true);
      let full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/shipment_list`;
      let sendData = {
        find: "",
        // shipment_status: shipment_status,
        indexValue: index,
        limit: otherStates.rowsPerPage,
        customer_id: urlCustomerID,
        date: "",
        search_with: searchwithstate.search_with,
      };
      console.log("sendData", sendData);
      sendData.find = order_number;
      sendData.status = statusNumbers;

      console.log("send", sendData);
      axios
        .post(full_api, sendData, { headers: exportValue.headers })
        .then((res) => {
          setIsLoading(false);
          if (index == 0 && onLoad) {
            setOtherState({
              ...otherStates,
              total_count: res.data.dataCount,
              page: index,
            });
          }

          setState({
            ...state,
            shipmnent_list: res.data.output,
            dataCount: res.data.dataCount,
            isLoading: false,
          });
        })
        .catch((e) => {
          setIsLoading(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          console.log("----error:   ", e);
        });
    } else {
      axios_get_api(null, 0, true);
    }
  }, [
    otherStates.rowsPerPage,
    searchfilters.filterStatus,
    customeridstate.customer_id,
    setDate.date,
    rtoShield,
  ]);

  //    useEffect(()=>{

  //     // Get and set the status array from the URL
  //     const urlStatus = urlSearchParams.get('status');
  //     if (urlStatus) {
  //       // Split the comma-separated values into an array
  //       const statusArray = urlStatus.split(',').map(Number); // Convert values to numbers
  //       setsearchFilters({...searchfilters,filterStatus:statusArray});
  //     }

  //    })

  const axios_get_api = (status, index = 0, onLoad = true) => {
    //  console.log("dstatus--->",shipment_status)
    console.log("onLoad--->", onLoad);
    setIsLoading(true);
    let full_api =
      exportValue.host +
      "/" +
      exportValue.version +
      "/" +
      exportValue.api +
      `/ndr_shipment_list`;
    let sendData = {
      // shipment_status: shipment_status,
      indexValue: index,
      limit: otherStates.rowsPerPage,
      customer_id: customeridstate.customer_id,
      status: status,
      search_with: searchwithstate.search_with,
      find: searchstate.search_shipment,
      rto_shield: rtoShield,
    };
    if (date.from_date != "" && date.to_date != "") {
      sendData.from_date = date.from_date;
      sendData.to_date = date.to_date;
    }
    console.log("sendData", sendData);
    // sendData.find = searchshipment.shipment_id
    if (searchfilters.filterStatus.length > 0) {
      sendData.status = searchfilters.filterStatus;
    }
    if (pendingOrder != null) {
      sendData.ndr_read_unread = 0;
    }

    console.log("send", sendData);
    axios
      .post(full_api, sendData, { headers: exportValue.headers })
      .then((res) => {
        setIsLoading(false);
        // console.log("index",index)
        // console.log("onLoad",onLoad)

        if (index == 0 && onLoad) {
          setOtherState({
            ...otherStates,
            total_count: res.data.dataCount,
            page: index,
          });
        }

        setState({
          ...state,
          shipmnent_list: res.data.output,
          dataCount: res.data.dataCount,
          count_all: res.data.count_all,
          count_action_required: res.data.count_action_required,
          count_action_requested: res.data.count_action_requested,
          count_delivered: res.data.count_delivered,
          count_rto: res.data.count_rto,
          count_pending: res.data.count_pending,
          count_ofd: res.data.count_ofd,
          customer_detail: res.data.customer,
          isLoading: false,
        });

        console.log("response", res.data.output);
        //      if (status != null) {
        //     console.log("loct - -   ", JSON.parse(status));
        //      setstatusFilters({...statusfilters, current_status:JSON.parse(status)})
        // }
      })
      .catch((e) => {
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log("----error:   ", e);
      });
  };

  React.useEffect(() => {
    if (title) {
      // setsearchFilters({...searchfilters,searchtitle:title})
    }
  }, []);

  const handlePageChange = (event, newPage) => {
    // console.log("newpage",newPage)
    setOtherState({ ...otherStates, page: newPage });
    //console.log("newPage ", newPage);
    axios_get_api(shipmentstate.shipment_status, newPage, true);

    // searchUser(state.searchValue,newPage)
  };
  const handleChangeRowsPerPage = (event, newPage) => {
    console.log("event ", event.target.value);
    console.log("newPage ", newPage);
    setOtherState({ ...otherStates, rowsPerPage: event.target.value, page: 0 });
  };

  const customerProfile = () => {
    let full_api =
      exportValue.host +
      "/" +
      exportValue.version +
      "/" +
      exportValue.api +
      `/customer_profile`;
    let sendData = {
      admin_type: admindata.admin_type,
      admin_id: admindata.admin_id,
    };

    axios
      .post(full_api, sendData, { headers: exportValue.headers })
      .then((res) => {
        setdimensionState(res.data.output);
        console.log("rnmmmmm", res);
      })
      .catch((e) => {
        // toast.configure()
        //toast.error("Some thing went wrong")
        console.log("----error:   ", e);
      });
  };

  const openModal = (sub) => {
    setndrmodal(true);
    setShipments({ shipment: sub });
  };
  const closemodal = (e) => {
    setndrmodal(false);
    setType({ ...typestate, type: 5 });
    setndrstate({
      ...ndrstate,
      ndr_date: "",
      ndr_address: "",
      ndr_phone: "",
      ndr_remarks: "",
    });
    setShipments({ shipment: {} });
  };

  const handleNDRchange = (e) => {
    setType({ ...typestate, type: e.target.value });
  };

  const handleNDRchnage = (e) => {
    setndrstate({ ...ndrstate, [e.target.name]: e.target.value });
  };

  const ndrReAttempt = () => {
    setndrloader(true);
    if (
      (typestate.type == 1 &&
        ndrstate.ndr_date != "" &&
        ndrstate.ndr_phone != "" &&
        ndrstate.remarks != "") ||
      (typestate.type == 2 &&
        ndrstate.ndr_date != "" &&
        ndrstate.ndr_address != "" &&
        ndrstate.remarks != "") ||
      (typestate.type == 0 &&
        ndrstate.ndr_date != "" &&
        ndrstate.remarks != "") ||
      (typestate.type == 3 && ndrstate.remarks != "")
    ) {
      let full_api = exportValue.apiUrl + `/shipment/ndr_re_attempt`;
      let sendData = {
        type: typestate.type,
        shipment: stateshipment.shipment,
        ndrstate,
      };
      console.log("sendData", sendData);

      axios
        .post(full_api, sendData, { headers: exportValue.headers })
        .then((res) => {
          if (res.data.status == true) {
            axios_get_api(
              shipmentstate.shipment_status,
              otherStates.page,
              true
            );
            setndrmodal(false);
            setType({ ...typestate, type: 5 });
            setndrstate({
              ...ndrstate,
              ndr_date: "",
              ndr_address: "",
              ndr_phone: "",
              ndr_remarks: "",
            });
            setShipments({ shipment: {} });
            setndrloader(false);

            const Toast = Swal.mixin({
              toast: true,
              position: "bottom-end",
              showConfirmButton: false,
              timer: 3000,
            });

            Toast.fire({
              background: "#3659cd",
              type: "success",
              title: res.data.message,
              color: "white",
            });
          } else {
            setndrmodal(false);
            setType({ ...typestate, type: 5 });
            setndrstate({
              ...ndrstate,
              ndr_date: "",
              ndr_address: "",
              ndr_phone: "",
              ndr_remarks: "",
            });
            setShipments({ shipment: {} });
            setndrloader(false);
            const Toast = Swal.mixin({
              toast: true,
              position: "bottom-end",
              showConfirmButton: false,
              timer: 3000,
            });

            Toast.fire({
              background: "#206bc4",
              type: "unsuccess",
              title: res.data.message,
              color: "white",
            });
          }
        })
        .catch((e) => {
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });

          Toast.fire({
            background: "#206bc4",
            type: "unsuccess",
            title: "Something Went Wrong ",
            color: "white",
          });
          setndrloader(false);
          // toast.configure()
          //toast.error("Some thing went wrong")
          // console.log("----error:   ", e);
        });
    } else {
      const Toast = Swal.mixin({
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
      });

      Toast.fire({
        background: "#206bc4",
        type: "unsuccess",
        title: "Please fill all the details ",
        color: "white",
      });
      setndrloader(false);
    }
  };

  const handleRecordingSelect = (recording) => {
    if (replySubmitted) return;

    setSelectedRecordings((prev) => {
      const alreadySelected = prev.find((r) => r.call_id === recording.call_id);
      if (alreadySelected) {
        return prev.filter((r) => r.call_id !== recording.call_id);
      } else {
        return [...prev, recording];
      }
    });
  };

  // Image upload handler
  const handleImageUpload = (event) => {
    if (!replySubmitted) {
      setImageFile(event.target.files[0]);
    }
  };

  // Handle dropdown selection
  const handleResponseChange = (event) => {
    const response = event.target.value;
    setSelectedResponse(response);

    // Auto-fill the reply text based on the selected response
    const predefinedComments = {
      "Not reachable":
        "Consignee not reachable, please provide alternate contact number",
      "Refused to accept":
        "Consignee refused to accept shipment. Please find attached call recording",
      "Fake attempt":
        "Fake attempt detected. Courier company has been intimated about the same and re-attempt has been arranged",
      "Damage Shipment":
        "Shipment damaged in transit. Please advise next course of action  1. Deliver Damaged shipment , 2. Return Damaged shipment ",
      "Incorrect/Incomplete Address":
        "Buyer address is incorrect/incomplete. Please provide correct and complete address",
    };

    setReplyText(predefinedComments[response] || "");
  };

  // Handle reply submission
  const handleReplySubmit = async () => {
    if (!replyText) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter reply details",
      });
      return;
    }

    if (selectedRecordings.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please select at least one call recording",
      });
      return;
    }

    const formData = new FormData();
    formData.append("reply", replyText);
    formData.append("shipment_id", viewModal.sub.shipment_id);
    formData.append("receiver_mobile", viewModal.sub.receiver[0].mobile);

    selectedRecordings.forEach((rec, index) => {
      formData.append(`mp3_file_${index + 1}`, rec.recording_url);
    });
    // Add image if uploaded
    if (imageFile) {
      formData.append("image", imageFile);
    }

    try {
      setReplySubmitted(true);
      const response = await axios.post(
        `${exportValue.host}/${exportValue.version}/${exportValue.api}/update_admin_submit_jp_action`,
        formData,
        { headers: exportValue.headers }
      );

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success...",
          text: "JP Action updated successfully!",
        });
        // Reset form
        setSelectedResponse("");
        setReplyText("");
        setImageFile(null);
        setSelectedRecordings([]);
        setReplySubmitted(false);
        setviewModal({ show: false, sub: {} });
        axios_get_api(shipmentstate.shipment_status, otherStates.page, true);
        // setTimeout(() => {
        //   window.location.reload();
        // }, 1000)
        // window.location.reload();
      }
    } catch (error) {
      setReplySubmitted(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "An error occurred. Please try again.",
      });
    }
  };

  const closemodaljp = () => {
    setviewModal({ show: false, sub: {} });
    setSelectedResponse("");
    setReplyText("");
    setMp3File(null);
  };

  function copyToClipboard(value) {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        console.log("Text copied to clipboard:", value);
        // Optionally, you can provide feedback to the user here
      })
      .catch((error) => {
        console.error("Failed to copy text to clipboard:", error);
        // Handle errors here
      });
  }

  const set_update = (sub) => {
    setviewModal({ show: true, sub: sub });
    update_jp(sub.shipment_id);
  };
  const update_jp = (shipment_id) => {
    try {
      let full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/update_jp_read_unread`;
      let sendData = { shipment_id: shipment_id };
      console.log("sendData", sendData);

      axios
        .post(full_api, sendData, { headers: exportValue.headers })
        .then((res) => {});
    } catch (error) {}
  };

  const handleEmailCarrier = async (item) => {
    if (selectedRecordings.length === 0) return;

    const awb = item.carrier_tracking_number; // Get the shipment AWB number dynamically
    const carrierId = item.carrier_id; // Get carrier id for current shipment

    try {
      let full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        `/send_fake_attempt_email`;
      let sendData = {
        carrierId,
        awb,
        recordings: selectedRecordings.map((rec) => rec.recording_url),
      };
      console.log("sendData", sendData);

      axios
        .post(full_api, sendData, { headers: exportValue.headers })
        .then((res) => {
          if (res.data.success == true) {
            Swal.fire({
              icon: "success",
              title: "Good Job...",
              text: res.data.message,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: res.data.message,
            });
          }
        });
    } catch (err) {
      // alert('Error sending email: ' + err.message);
    }
  };

  const dateselect = (e) => {
    setdate({
      ...date,
      [e.target.name]: moment(e.target.value).format("YYYY-MM-DD"),
    });
  };
  const shipmentFilter = (status) => {
    // console.log("action ", status);
    setshipStatus({ ...shipmentstate, shipment_status: status });
    // shipmentList(status, 0, true)
    axios_get_api(status, otherStates.page, true);
  };

  const handlesearchShipment = (e) => {
    setsearchstate({ search_shipment: e.target.value });
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const filteredShipments = state.shipment_list
        .filter((shipment) => shipment.ndr_action_required === 0) // Filter shipments with ndr_action_required = 0
        .map((shipment) => shipment.shipment_id); // Map to shipment_id

      setSelectedShipments(filteredShipments);
      setSelectCount({ select_count: filteredShipments.length });
    } else {
      setSelectedShipments([]);
      setSelectCount({ select_count: 0 });
    }
  };

  const handleSelectIndividual = (event, shipmentId, ndrActionRequired) => {
    if (ndrActionRequired !== 0) return; // Prevent selection if ndr_action_required is not 0

    if (event.target.checked) {
      setSelectedShipments([...selectedShipments, shipmentId]);
      setSelectCount({
        ...selectCount,
        select_count: selectCount.select_count + 1,
      });
    } else {
      setSelectedShipments(selectedShipments.filter((id) => id !== shipmentId));
      setSelectCount({
        ...selectCount,
        select_count: selectCount.select_count - 1,
      });
    }
  };

  const openOffdetailcanvasHandler = (sub) => {
    setOpenOffdetailcanvas(true);
    setbookorder(sub);
    shipment_tracking(sub.shipment_id);
  };
  const shipment_tracking = (invoice_id) => {
    let full_api = exportValue.apiUrl + `/shipment/shipment_tracking`;
    let sendData = { trackingNumber: invoice_id };
    // console.log("sendData",sendData)

    axios
      .post(full_api, sendData, { headers: exportValue.headers })
      .then((res) => {
        if (res.data.status == 200) {
          console.log("2000 ");
          setTrackingState({
            ...trackingstate,
            track: res.data.output,
            isLoading: false,
          });
          // console.log("res",trackingstate.track)
          setStateship({
            ...stateship,
            shipmentDetail: res.data.ship_detail,
            isLoading: false,
          });
        } else {
          console.log("5000");
          setTrackingState({
            ...trackingstate,
            track: res.data.output,
            isLoading: false,
          });
          // console.log("res",trackingstate.track)
          setStateship({
            ...stateship,
            shipmentDetail: res.data.ship_detail,
            isLoading: false,
          });
        }
      })
      .catch((e) => {
        // toast.configure()
        //toast.error("Some thing went wrong")
        // console.log("----error:   ", e);
      });
  };

  const closeOffdetailcanvasHandler = () => {
    setOpenOffdetailcanvas(false);
    setbookorder([]);
    setTrackingState({ track: {}, isLoading: true });
    setStateship({
      shipmentDetail: { sender: {}, receiver: {}, items: [] },
      isLoading: true,
      detailFound: false,
      parcel_count: 0,
    });
  };
  const openHistory = (shipment) => {
    let history = [];

    // if (shipment.ndr_flow?.sms) {
    //   history.push({
    //     mode: "SMS",
    //     triggered_at: shipment.ndr_flow.sms.sent_at,
    //     response: shipment.ndr_flow.sms.response || "No",
    //     response_at: shipment.ndr_flow.sms.response_at,
    //   });
    // }

    if (shipment.ndr_flow?.whatsapp) {
      history.push({
        mode: "WA",
        triggered_at: shipment.ndr_flow.whatsapp.sent_at,
        response: shipment.ndr_flow.whatsapp.response || "No",
        response_at: shipment.ndr_flow.whatsapp.response_at,
      });
    }

    if (shipment.ndr_flow?.ivr?.attempt1) {
      history.push({
        mode: "IVR-1",
        triggered_at: shipment.ndr_flow.ivr.attempt1.sent_at,
        response: shipment.ndr_flow.ivr.attempt1.response || "No",
        response_at: shipment.ndr_flow.ivr.attempt1.response_at,
      });
    }

    if (shipment.ndr_flow?.ivr?.attempt2) {
      history.push({
        mode: "IVR-2",
        triggered_at: shipment.ndr_flow.ivr.attempt2.sent_at,
        response: shipment.ndr_flow.ivr.attempt2.response || "No",
        response_at: shipment.ndr_flow.ivr.attempt2.response_at,
      });
    }

    if (shipment.ndr_flow?.ivr?.attempt3) {
      history.push({
        mode: "IVR-3",
        triggered_at: shipment.ndr_flow.ivr.attempt3.sent_at,
        response: shipment.ndr_flow.ivr.attempt3.response || "No",
        response_at: shipment.ndr_flow.ivr.attempt3.response_at,
      });
    }

    setCommunicationHistory(history);
  };

  const getLastAction = (shipment) => {
    if (shipment.ndr_flow?.response === "Cancel") return "Cancelled by Buyer";

    if (shipment.ndr_flow?.response === "Reattempt")
      return "Re-attempt by Buyer";

    if (shipment.ndr_action === "seller_reattempt")
      return "Re-attempt by Seller";

    if (shipment.ndr_action === "seller_cancel") return "Cancelled by Seller";

    if (shipment?.rto_shield === true) {
      return "Re-attempt by JetPost";
    }
  };

  const parseNdrDate = (rawDate) => {
    if (!rawDate) return null;

    const parsed = moment(
      rawDate,
      [
        moment.ISO_8601, // ISO formats
        "DD-MM-YYYY HH:mm:ss", // 20-03-2026 11:07:25
      ],
      true // strict parsing
    );

    return parsed.isValid() ? parsed : null;
  };
  return (
    <div>
      <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <section class="home-section">
        <Sub_header />
        <Modal show={viewModal.show} onHide={() => closemodaljp()} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>JP Actions</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="card p-2 mb-2">
              <div className="row">
                <div className="col-12 col-md">
                  {viewModal.sub.service_provider}
                  <br />
                  {viewModal.sub.carrier_tracking_number}
                </div>
                <div className="col-12 col-md">
                  <div class="text-success">
                    {viewModal.sub.total_ndr_attempt} Attempt(s)
                  </div>
                  <small>
                    <a
                      onClick={() => {
                        sethistory({
                          ndr_history: viewModal.sub.ndr_array || [],
                          awb: viewModal.sub.carrier_tracking_number,
                        });
                        setShowNDRModal(true);
                      }}
                      style={{ cursor: "pointer" }}
                      data-bs-toggle="modal"
                      data-bs-target="#NDR_Modal"
                      data-bs-backdrop="false"
                      class="text-info"
                    >
                      (Show History)
                    </a>
                  </small>
                </div>
              </div>
            </div>
            {loginError && (
              <div className="alert alert-danger">{loginError}</div>
            )}
            <div class="card p-2 mb-2">
              <div className="row">
                {viewModal.sub.sender ? (
                  <div class="col-12 col-md">
                    <h6>Ship From:</h6>
                    <small class="text-muted">Sender Name:</small>
                    <p>{viewModal.sub.sender[0].name}</p>
                    <small class="text-muted">Sender Address:</small>
                    <p>
                      {viewModal.sub.sender[0].address},{" "}
                      {viewModal.sub.sender[0].city},{" "}
                      {viewModal.sub.sender[0].state}{" "}
                      {viewModal.sub.sender[0].pincode}
                    </p>
                    <small class="text-muted">Sender Email:</small>
                    <p>{viewModal.sub.sender[0].email}</p>
                    <small class="text-muted">Sender Mobile:</small>
                    <p>
                      {viewModal.sub.sender[0].mobile}
                      <button
                        className="btn btn-danger"
                        onClick={handleCallShipper}
                        disabled={
                          !isInitialized ||
                          shipperCall.status === "calling" ||
                          shipperCall.status === "ringing" ||
                          shipperCall.status === "connected"
                        }
                      >
                        {shipperCall.status === "connected"
                          ? `In Call (${shipperCall.duration}s)`
                          : shipperCall.status === "ringing"
                          ? "Ringing..."
                          : shipperCall.status === "calling"
                          ? "Calling..."
                          : "Call Shipper"}
                      </button>
                      {(shipperCall.status === "connected" ||
                        shipperCall.status === "ringing") && (
                        <button
                          className="btn btn-warning ms-2"
                          onClick={endCall}
                        >
                          End Call
                        </button>
                      )}
                    </p>
                  </div>
                ) : (
                  ""
                )}
                {viewModal.sub.receiver ? (
                  <div class="col-12 col-md">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6>Ship To:</h6>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => setShowEditConsignee(!showEditConsignee)}
                      >
                        {showEditConsignee ? "Cancel" : "Edit"}
                      </button>
                    </div>
                    {showEditConsignee ? (
                      <div className="edit-consignee-form mb-3">
                        <div className="mb-2">
                          <label className="form-label">
                            Select Field to Edit:
                          </label>
                          <select
                            className="form-select mb-3"
                            value={selectedConsigneeField}
                            onChange={(e) =>
                              setSelectedConsigneeField(e.target.value)
                            }
                          >
                            <option value="">Select field</option>
                            <option value="name">Name</option>
                            <option value="address">Address</option>
                            <option value="mobile">Mobile</option>
                            <option value="payment_mode">Payment Mode</option>
                          </select>
                        </div>

                        {selectedConsigneeField === "name" && (
                          <div className="mb-2">
                            <label className="form-label">Receiver Name:</label>
                            <input
                              type="text"
                              className="form-control"
                              value={editedConsignee.name}
                              onChange={(e) =>
                                setEditedConsignee({
                                  ...editedConsignee,
                                  name: e.target.value,
                                })
                              }
                            />
                          </div>
                        )}

                        {selectedConsigneeField === "address" && (
                          <div className="mb-2">
                            <label className="form-label">
                              Receiver Address:
                            </label>
                            <textarea
                              className="form-control"
                              value={editedConsignee.address}
                              onChange={(e) =>
                                setEditedConsignee({
                                  ...editedConsignee,
                                  address: e.target.value,
                                })
                              }
                            />
                          </div>
                        )}

                        {selectedConsigneeField === "mobile" && (
                          <div className="mb-2">
                            <label className="form-label">
                              Receiver Mobile:
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={editedConsignee.mobile}
                              onChange={(e) =>
                                setEditedConsignee({
                                  ...editedConsignee,
                                  mobile: e.target.value,
                                })
                              }
                            />
                          </div>
                        )}

                        {selectedConsigneeField === "payment_mode" && (
                          <div className="mb-2">
                            <label className="form-label">Payment Mode:</label>

                            {/* If payment_mode is prepaid, show COD as locked */}
                            {editedConsignee.payment_mode === "prepaid" && (
                              <select
                                className="form-select"
                                value="cod"
                                disabled
                              >
                                <option value="cod">COD</option>
                              </select>
                            )}

                            {/* If payment_mode is cod, show Prepaid as locked */}
                            {editedConsignee.payment_mode === "cod" && (
                              <select
                                className="form-select"
                                value="prepaid"
                                disabled
                              >
                                <option value="prepaid">Prepaid</option>
                              </select>
                            )}

                            {/* Show COD amount field ONLY if payment_mode is prepaid (which shows COD as locked) */}
                            {editedConsignee.payment_mode === "prepaid" && (
                              <div className="mt-2">
                                <label className="form-label">
                                  COD Amount:
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={editedConsignee.cod_amount || ""}
                                  onChange={(e) =>
                                    setEditedConsignee({
                                      ...editedConsignee,
                                      cod_amount: e.target.value,
                                    })
                                  }
                                  placeholder="Enter COD amount"
                                />
                              </div>
                            )}
                          </div>
                        )}

                        {selectedConsigneeField && (
                          <button
                            className="btn btn-sm btn-success"
                            onClick={handleConsigneeUpdate}
                            disabled={
                              isUpdatingConsignee ||
                              !editedConsignee[selectedConsigneeField] ||
                              (selectedConsigneeField === "payment_mode" &&
                                editedConsignee.payment_mode === "prepaid" && // UI shows COD as locked
                                !editedConsignee.cod_amount)
                            }
                          >
                            {isUpdatingConsignee ? "Updating..." : "Update"}
                          </button>
                        )}
                      </div>
                    ) : (
                      <>
                        <small class="text-muted">Receiver Name:</small>
                        <p>{viewModal.sub.receiver[0].name}</p>
                        <small class="text-muted">Receiver Address:</small>
                        <p>
                          {viewModal.sub.receiver[0].address},{" "}
                          {viewModal.sub.receiver[0].city},{" "}
                          {viewModal.sub.receiver[0].state}{" "}
                          {viewModal.sub.receiver[0].pincode}
                        </p>
                        <small class="text-muted">Receiver Email:</small>
                        <p>{viewModal.sub.receiver[0].email}</p>
                        <small class="text-muted">Receiver Mobile:</small>
                        <p>
                          {viewModal.sub.receiver[0].mobile}
                          <button
                            className="btn btn-success text-white"
                            onClick={handleCallConsignee}
                            disabled={
                              !isInitialized ||
                              consigneeCall.status === "calling" ||
                              consigneeCall.status === "ringing" ||
                              consigneeCall.status === "connected"
                            }
                          >
                            {consigneeCall.status === "connected"
                              ? `In Call (${consigneeCall.duration}s)`
                              : consigneeCall.status === "ringing"
                              ? "Ringing..."
                              : consigneeCall.status === "calling"
                              ? "Calling..."
                              : "Call Consignee"}
                          </button>
                          {(consigneeCall.status === "connected" ||
                            consigneeCall.status === "ringing") && (
                            <button
                              className="btn btn-warning ms-2"
                              onClick={endCall}
                            >
                              End Call
                            </button>
                          )}
                        </p>
                      </>
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            {viewModal.sub.jp_array ? (
              <div className="card p-2 mt-2 mb-3">
                {viewModal.sub.jp_array.map((item) => (
                  <section className="chatting_lists">
                    {item.replied_by == "Admin" ? (
                      <div className="chat_list left_hand">
                        <img
                          src={`https://avatar.iran.liara.run/username?username=${item.replied_name}`}
                          className="img-fluid chat_list_img"
                          alt={`${item.replied_name}`}
                        />
                        <div>
                          <p>{item.reply ? item.reply : ""}</p>
                          {/* <strong>- Michel Wilson</strong> <small>just now</small> */}
                          <small>
                            <Moment format="MMM DD YYYY hh:mm">
                              {item.timestamp}
                            </Moment>
                          </small>
                          <h6>Attachments</h6>
                          {item.mp3_file &&
                            (Array.isArray(item.mp3_file)
                              ? item.mp3_file.length > 0 &&
                                item.mp3_file.map((file, idx) => {
                                  const url = file.startsWith(
                                    "https://cdn.thejetpost.in/customer_assets/"
                                  )
                                    ? file
                                    : `https://cdn.thejetpost.in/customer_assets/${file}`;
                                  return (
                                    <audio
                                      key={idx}
                                      controls
                                      className="me-2 mb-2 d-block"
                                    >
                                      <source src={url} type="audio/mpeg" />
                                    </audio>
                                  );
                                })
                              : typeof item.mp3_file === "string" &&
                                item.mp3_file.trim() !== "" && (
                                  <audio controls className="me-2 mb-2 d-block">
                                    <source
                                      src={
                                        item.mp3_file.startsWith(
                                          "https://cdn.thejetpost.in/customer_assets/"
                                        )
                                          ? item.mp3_file
                                          : `https://cdn.thejetpost.in/customer_assets/${item.mp3_file}`
                                      }
                                      type="audio/mpeg"
                                    />
                                  </audio>
                                ))}
                          <br />
                          <br />

                          {item.image_file && item.image_file != null ? (
                            <img
                              className=""
                              height="100px"
                              src={item.image_file}
                            ></img>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="chat_list right_hand">
                        <img
                          src={`https://avatar.iran.liara.run/username?username=${item.replied_name}`}
                          className="img-fluid chat_list_img"
                          alt={`${item.replied_name}`}
                        />
                        <div>
                          <p>{item.reply ? item.reply : ""}</p>
                          <small>
                            <Moment format="MMM DD YYYY hh:mm">
                              {item.timestamp}
                            </Moment>
                          </small>
                        </div>
                      </div>
                    )}
                  </section>
                ))}
              </div>
            ) : (
              ""
            )}
            <div className="row" id="reaise_disp">
              {/* Dropdown for predefined responses */}
              <div className="col-12 col-md-12 mb-3">
                <Form.Label>Predefined Response:</Form.Label>
                <Form.Select
                  value={selectedResponse}
                  onChange={handleResponseChange}
                >
                  <option value="">Select a response</option>
                  <option value="Not reachable">Not reachable</option>
                  <option value="Refused to accept">Refused to accept</option>
                  <option value="Fake attempt">Fake attempt</option>
                  <option value="Damage Shipment">Damage Shipment</option>
                  <option value="Incorrect/Incomplete Address">
                    Incorrect/Incomplete Address
                  </option>
                </Form.Select>
              </div>

              {/* Textarea for reply */}
              <div className="col-12 col-md-12 mb-3">
                <Form.Label>Enter Details:</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={5}
                  value={replyText}
                  onChange={(e) => setReplyText(e.target.value)}
                  placeholder="Enter details"
                />
              </div>
              <div className="card p-3 mt-3">
                <h5>Call Recordings</h5>
                {isLoading ? (
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p>Loading recordings...</p>
                  </div>
                ) : callRecordings.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Select</th>
                          <th>Mobile Number</th>
                          <th>Date</th>
                          <th>Duration</th>
                          <th>Play</th>
                        </tr>
                      </thead>
                      <tbody>
                        {callRecordings.map((rec) => (
                          <tr key={rec.call_id}>
                            <td>
                              <input
                                type="checkbox"
                                checked={selectedRecordings.some(
                                  (r) => r.call_id === rec.call_id
                                )}
                                onChange={() => handleRecordingSelect(rec)}
                                disabled={replySubmitted}
                              />
                            </td>
                            <td>{rec.phone_number}</td>
                            <td>
                              <Moment format="MMM DD hh:mm A">
                                {rec.timestamp}
                              </Moment>
                            </td>
                            <td>{rec.duration} sec</td>
                            <td>
                              <audio controls style={{}}>
                                <source
                                  src={`https://cdn.thejetpost.in/customer_assets/${rec.recording_url}`}
                                  type="audio/mpeg"
                                />
                              </audio>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="alert alert-warning">
                    No call recordings available. Please make a call first.
                  </div>
                )}
              </div>
              {selectedRecordings.length > 0 && (
                <div className="mt-4">
                  <h6>Selected Recordings</h6>
                  <ul className="list-group">
                    {selectedRecordings.map((rec) => (
                      <li
                        key={rec.call_id}
                        className="list-group-item d-flex align-items-center"
                      >
                        <audio controls style={{ width: "200px" }}>
                          <source
                            src={`https://cdn.thejetpost.in/customer_assets/${rec.recording_url}`}
                            type="audio/mpeg"
                          />
                        </audio>
                      </li>
                    ))}
                  </ul>
                  {replyText.includes("Fake attempt") && (
                    <button
                      className="btn btn-danger mt-1 mb-3"
                      onClick={() => handleEmailCarrier(viewModal.sub)}
                      disabled={
                        replySubmitted || selectedRecordings.length === 0
                      }
                    >
                      Email Carrier
                    </button>
                  )}
                </div>
              )}

              {/* Image Upload Section */}
              <div className="col-12 col-md-12 mb-3">
                <Form.Label>Upload Image:</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  disabled={replySubmitted}
                />
                {imageFile && (
                  <div className="mt-2">
                    <small>Selected image: {imageFile.name}</small>
                    <img
                      src={URL.createObjectURL(imageFile)}
                      alt="Preview"
                      className="img-thumbnail mt-2"
                      style={{ maxHeight: "100px" }}
                    />
                  </div>
                )}
              </div>

              {/* Submit Button */}
              <div className="col-12 col-md-12 mb-3">
                <button
                  className="btn btn-primary"
                  onClick={handleReplySubmit}
                  disabled={replySubmitted || selectedRecordings.length === 0}
                >
                  {replySubmitted ? "Submitting..." : "Submit Reply"}
                </button>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-secondary"
              onClick={() => closemodaljp()}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* <div class="modal" id="NDR_Modal" data-bs-backdrop="false">

          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">NDR History: AWB #{history.awb}</h4>
                <button type="button" onClick={(e) => sethistory({ ndr_history: [], awb: "" })} class="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div class="modal-body">
                <div class="table-responsive">
                  <table class="table table-bordered table-hover table-sm">
                    <thead class="bg-table">
                      <tr>
                        <th>Date</th>
                        <th>Action</th>
                        <th>Updated Details (If Any)</th>
                        <th>Remarks</th>
                        <th>NDR Count #</th>
                        <th>By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {history.ndr_history.length > 0 ?
                        history.ndr_history.map((his) => (
                          <tr>
                            <td>{his.date}</td>
                            <td>{his.action}</td>
                            <td>{his.updated_details}</td>
                            <td>{his.remarks}</td>
                            <td class="text-center">{his.ndr_count}</td>
                            <td>{his.by}</td>
                          </tr>
                        )) : ""}

                    </tbody>
                  </table>
                </div>
              </div>
            </div>

          </div>
       
        </div> */}

        <Modal
          show={showNDRModal}
          onHide={() => {
            setShowNDRModal(false);
            sethistory({ ndr_history: [], awb: "" });
          }}
          size="xl"
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>NDR History: AWB #{history.awb}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="table-responsive">
              <table className="table table-bordered table-hover table-sm">
                <thead className="bg-table">
                  <tr>
                    <th>Date</th>
                    <th>Action</th>
                    <th>Updated Details (If Any)</th>
                    <th>Remarks</th>
                    <th>NDR Count #</th>
                    <th>By</th>
                  </tr>
                </thead>
                <tbody>
                  {history.ndr_history.length > 0 ? (
                    history.ndr_history.map((his, idx) => (
                      <tr key={idx}>
                        <td>{his.date}</td>
                        <td>{his.action}</td>
                        <td>{his.updated_details}</td>
                        <td>{his.remarks}</td>
                        <td className="text-center">{his.ndr_count}</td>
                        <td>{his.by}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No History Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Modal.Body>
        </Modal>

        <section class="mt-3">
          <div class="row mb-3">
            <div class="col-12 col-md-2">
              <h5>NDR Shipments</h5>
            </div>
          </div>
          <div class="card mb-3">
            <div class="card-body">
              <div class="row justify-content-between">
                <div class="col-12 col-md-3 mb-1">
                  <div class="row">
                    {/* <div class="col-12 col-md-6"> */}
                    <div class="input-group">
                      <input
                        type="date"
                        class="form-control"
                        name="from_date"
                        onChange={(e) => dateselect(e)}
                        value={date.from_date}
                      />
                      <input
                        type="date"
                        class="form-control"
                        name="to_date"
                        onChange={(e) => dateselect(e)}
                        value={date.to_date}
                      />

                      <span class="input-group-text">
                        <i
                          class="fa fa-search"
                          onClick={(e) =>
                            axios_get_api(
                              shipmentstate.shipment_status,
                              otherStates.page,
                              true
                            )
                          }
                        ></i>
                      </span>
                    </div>
                    {/* </div> */}
                  </div>
                </div>
                <div class="col-12 col-md-3 mb-1">
                  <div class="row justify-content-between">
                    <div class="input-group input-group-sm mb-3">
                      <input
                        type="text"
                        class="form-control w-50"
                        name="search_shipment"
                        placeholder="Enter tracking number / JPID"
                        onChange={(e) => handlesearchShipment(e)}
                        value={searchstate.search_shipment}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            axios_get_api(
                              shipmentstate.shipment_status,
                              otherStates.page,
                              true
                            );
                          }
                        }}
                      />
                      <button
                        class="btn btn-outline-primary"
                        onClick={(e) =>
                          axios_get_api(
                            shipmentstate.shipment_status,
                            otherStates.page,
                            true
                          )
                        }
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <select
                    class="form-select form-select-sm"
                    value={rtoShield}
                    onChange={(e) => {
                      setRtoShield(e.target.value);
                    }}
                  >
                    <option value="ON">TrueReach™ Shield ON</option>
                    <option value="OFF">TrueReach™ Shield OFF</option>
                    <option value="BOTH">All</option>
                  </select>
                </div>
                <div class="col-6 col-md-3">
                  <button
                    class="btn btn-danger btn-sm"
                    onClick={() => axios_get_api("ESCALATION", 0, true)}
                  >
                    Escalations
                  </button>
                </div>
              </div>
            </div>
          </div>
          <ul class="nav nav-pills mb-2">
            <li class="nav-item">
              <a
                class={
                  shipmentstate.shipment_status == null
                    ? "nav-link active"
                    : "nav-link"
                }
                onClick={() => shipmentFilter(null)}
                style={{ cursor: "pointer" }}
              >
                All ({state.count_all})
              </a>
            </li>
            {/* <li class="nav-item">
                      <a class={(shipmentstate.shipment_status == 0) ? 'nav-link active' : 'nav-link'} onClick={() => shipmentFilter(0)} style={{ cursor: "pointer" }}>Action Required ({state.count_action_required})</a>
                    </li>
                    <li class="nav-item">
                      <a class={(shipmentstate.shipment_status == 1) ? 'nav-link active' : 'nav-link'} onClick={() => shipmentFilter(1)} style={{ cursor: "pointer" }}>Action Requested ({state.count_action_requested})</a>
                    </li> */}
            <li class="nav-item">
              <a
                class={
                  shipmentstate.shipment_status == 0
                    ? "nav-link active"
                    : "nav-link"
                }
                onClick={() => shipmentFilter(0)}
                style={{ cursor: "pointer" }}
              >
                Pending({state.count_pending})
              </a>
            </li>
            <li class="nav-item">
              <a
                class={
                  shipmentstate.shipment_status == 4
                    ? "nav-link active"
                    : "nav-link"
                }
                onClick={() => shipmentFilter(4)}
                style={{ cursor: "pointer" }}
              >
                OFD({state.count_ofd})
              </a>
            </li>

            <li class="nav-item">
              <a
                class={
                  shipmentstate.shipment_status == 2
                    ? "nav-link active"
                    : "nav-link"
                }
                onClick={() => shipmentFilter(2)}
                style={{ cursor: "pointer" }}
              >
                Delivered ({state.count_delivered})
              </a>
            </li>
            <li class="nav-item">
              <a
                class={
                  shipmentstate.shipment_status == 3
                    ? "nav-link active"
                    : "nav-link"
                }
                onClick={() => shipmentFilter(3)}
                style={{ cursor: "pointer" }}
              >
                RTO ({state.count_rto})
              </a>
            </li>
          </ul>
          {isLoading ? (
            <div
              style={{
                backgroundColor: "#f1f5f9",
                zIndex: 2,
                height: "100%",
                width: "100%",
                position: "absolute",
                opacity: "0.4",
              }}
            >
              <div style={{ left: "47%", top: "45%", position: "absolute" }}>
                <ReactLoading
                  type={"spin"}
                  color={"#000000"}
                  height={300}
                  width={89}
                />
              </div>
            </div>
          ) : (
            <div class="card card-body border-0 shadow table-wrapper table-responsive ">
              <table class="table table-hover  shipm_tablew">
                <thead>
                  <tr>
                    {/* <th><input class="form-check-input form-check-input-lg" type="checkbox" onChange={handleSelectAll} /></th> */}
                    <th class="border-gray-200">AWB #</th>
                    <th class="border-gray-200">Origin</th>
                    <th class="border-gray-200">Destination</th>
                    <th class="border-gray-200 ship_pickup">Sender</th>
                    <th class="border-gray-200">Receiver</th>
                    <th class="border-gray-200">Carrier</th>
                    <th class="border-gray-200">Payment Mode</th>
                    <th class="border-gray-200">Status</th>
                    <th class="border-gray-200">Exception</th>
                    <th class="border-gray-200">Last Action</th>
                    <th class="border-gray-200">Action</th>
                    <th class="border-gray-200">JP Action</th>
                    <th class="border-gray-200">History</th>
                  </tr>
                </thead>
                <tbody>
                  {/* <!-- Item --> */}
                  {state.shipmnent_list.length > 0
                    ? state.shipmnent_list.map((item) => (
                        <tr>
                          <td>
                            {/* <td><input class="form-check-input form-check-input-lg" type="checkbox" onClick={(e) => handleSelectIndividual(e, item.shipment_id, item.ndr_action_required)}
                                          checked={selectedShipments.includes(item.shipment_id)}
                                          disabled={item.ndr_action_required !== 0} /></td> */}
                            <h5>
                              <a
                                onClick={() => openOffdetailcanvasHandler(item)}
                                style={{ cursor: "pointer" }}
                                class="text-info fw-700 fs-6"
                              >
                                {item.carrier_tracking_number
                                  ? item.carrier_tracking_number
                                  : ""}
                              </a>
                              <a
                                onClick={() =>
                                  copyToClipboard(
                                    item.carrier_tracking_number
                                      ? item.carrier_tracking_number
                                      : item.shipment_id
                                  )
                                }
                              >
                                <i class="fa fa-clone" aria-hidden="true"></i>
                              </a>
                            </h5>
                            <h3>
                              O ID:{" "}
                              <a
                                onClick={() => openOffdetailcanvasHandler(item)}
                                style={{ cursor: "pointer" }}
                                class="text-info fw-700 fs-6"
                              >
                                {item.order_number}
                              </a>{" "}
                              <a
                                onClick={() =>
                                  copyToClipboard(item.order_number)
                                }
                              >
                                <i class="fa fa-clone" aria-hidden="true"></i>
                              </a>
                            </h3>
                            {/* <h6><Moment format="MMM DD YYYY hh:mm">
                          {new Date(item.created * 1000)}
                        </Moment>
                        </h6> */}
                            {item?.ndr_array?.[0]?.date &&
                              (() => {
                                const parsed = parseNdrDate(
                                  item.ndr_array[0].date
                                );

                                if (!parsed) return null;

                                return (
                                  <div>
                                    <small>
                                      {parsed.format("MMM DD YYYY")} -{" "}
                                      {parsed.format("hh:mm:ss A")}
                                    </small>
                                  </div>
                                );
                              })()}
                          </td>
                          <td>
                            {item.sender[0].city} <br />
                            <small>{item.sender[0].country}</small>
                          </td>
                          <td>
                            {item.receiver[0].city} <br />
                            <small>{item.receiver[0].country}</small>
                          </td>
                          <td class="">
                            <strong>{item.sender[0].name}</strong>
                            <br />
                            <small>{item.jp_id}</small>
                          </td>
                          <td>
                            <strong>{item.receiver[0].name}</strong>
                          </td>
                          <td>
                            <img
                              src={`https://cdn.thejetpost.in/images/${item.carrier_image}`}
                              alt=""
                              class="img-fluid"
                            />
                          </td>
                          <td class="fw-700 ">
                            {item.payment_mode == "cod" ? (
                              <strong className="text-danger">COD</strong>
                            ) : item.payment_mode == "prepaid" ? (
                              <strong className="text-success">PREPAID</strong>
                            ) : (
                              ""
                            )}
                          </td>
                          <td>
                            {item.status == 0 ? (
                              <span class="status pickup_awit">
                                {" "}
                                <i
                                  class="fa fa-clock-o"
                                  aria-hidden="true"
                                ></i>{" "}
                                Pending
                              </span>
                            ) : item.status == 10 ? (
                              <span class="status pickup_awit">
                                {" "}
                                <i
                                  class="fa fa-clock-o"
                                  aria-hidden="true"
                                ></i>{" "}
                                RTO
                              </span>
                            ) : item.status == 1 ? (
                              <span class="status pickup_awit">
                                {" "}
                                <i
                                  class="fa fa-clock-o"
                                  aria-hidden="true"
                                ></i>{" "}
                                Pickup Awaited
                              </span>
                            ) : item.status == 2 ? (
                              <span class="status pickedup">
                                {" "}
                                <i
                                  class="fa fa-check"
                                  aria-hidden="true"
                                ></i>{" "}
                                Picked Up
                              </span>
                            ) : item.status == 3 ? (
                              <span class="status in_transit">
                                {" "}
                                <i
                                  class="fa fa-truck"
                                  aria-hidden="true"
                                ></i>{" "}
                                In Transit
                              </span>
                            ) : item.status == 4 ? (
                              <span class="status out_f_deli">
                                {" "}
                                <i
                                  class="fa fa-plane"
                                  aria-hidden="true"
                                ></i>{" "}
                                Out for Delivery
                              </span>
                            ) : item.status == 5 ? (
                              <span class="status delivered">
                                {" "}
                                <i
                                  class="fa fa-check-square-o"
                                  aria-hidden="true"
                                ></i>{" "}
                                Delivered
                              </span>
                            ) : item.status == 6 ? (
                              <span class="status cancelled">
                                {" "}
                                <i
                                  class="fa fa-ban"
                                  aria-hidden="true"
                                ></i>{" "}
                                Cancelled
                              </span>
                            ) : item.status == 7 ? (
                              <span class="status failed">
                                {" "}
                                <i
                                  class="fa fa-exclamation-circle"
                                  aria-hidden="true"
                                ></i>{" "}
                                Failed
                              </span>
                            ) : item.status == 8 ? (
                              <span class="status pickup_awit">
                                {" "}
                                <i
                                  class="fa fa-clock-o"
                                  aria-hidden="true"
                                ></i>{" "}
                                NDR
                              </span>
                            ) : item.status == 19 ? (
                              <span class="status pickup_awit">
                                {" "}
                                <i
                                  class="fa fa-clock-o"
                                  aria-hidden="true"
                                ></i>{" "}
                                RTO In Transit
                              </span>
                            ) : item.status == 16 ? (
                              <span class="status pickup_awit">
                                {" "}
                                <i
                                  class="fa fa-clock-o"
                                  aria-hidden="true"
                                ></i>{" "}
                                RTO Delivered
                              </span>
                            ) : item.status == 9 ? (
                              <>
                                {" "}
                                <span class="status pickup_sechdls">
                                  {" "}
                                  <i
                                    class="fa fa-calendar-o"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Pickup Scheduled
                                </span>
                                <br />
                                <br />
                                {item.pickup_date != undefined &&
                                item.pickup_date != "" ? (
                                  <small>
                                    on{" "}
                                    {item.pickup_date != undefined
                                      ? item.pickup_date
                                      : ""}{" "}
                                    at{" "}
                                    {item.pickup_time != undefined
                                      ? item.pickup_time
                                      : ""}
                                  </small>
                                ) : (
                                  ""
                                )}{" "}
                              </>
                            ) : (
                              <span class="status pickup_awit">
                                {" "}
                                <i
                                  class="fa fa-clock-o"
                                  aria-hidden="true"
                                ></i>{" "}
                                Not Available
                              </span>
                            )}
                            {/* <span class="status pickup_awit"> <i class="fa fa-clock-o" aria-hidden="true"></i> Pickup Awaited</span> */}
                          </td>
                          <td>
                            <div class="text-success">
                              {item.total_ndr_attempt} Attempt(s)
                            </div>
                            <small>
                              <a
                                onClick={() => {
                                  sethistory({
                                    ndr_history: item.ndr_array
                                      ? item.ndr_array
                                      : [],
                                    awb: item.carrier_tracking_number,
                                  });
                                  setShowNDRModal(true);
                                }}
                                style={{ cursor: "pointer" }}
                                data-bs-toggle="modal"
                                data-bs-target="#NDR_Modal"
                                data-bs-backdrop="false"
                                class="text-info"
                              >
                                (Show History)
                              </a>
                            </small>
                          </td>
                          {/* <td>{item.ndr_action_on ? <><Moment format="YYYY-MM-DD">
                                          {new Date(item.ndr_action_on * 1000)}
                                        </Moment>
                                          <br />
                                          <Moment format="hh:mm:ss">
                                            {new Date(item.ndr_action_on * 1000)}
                                          </Moment> </> : ""}</td> */}
                          <td>{getLastAction(item)}</td>

                          <td>
                            <div class="text-success">
                              {shipmentstate.shipment_status == 0 &&
                              item.ndr_action_required === 0 ? (
                                <div class="btn-group">
                                  <a
                                    type="button"
                                    class="btn btn-primary "
                                    onClick={(e) => openModal(item)}
                                  >
                                    Take NDR Action
                                  </a>
                                </div>
                              ) : item.ndr_action_required != 0 ? (
                                item.ndr_array ? (
                                  item.ndr_array[0].action
                                ) : (
                                  ""
                                )
                              ) : (
                                ""
                              )}
                            </div>

                            {/* <div class="text-success">
  {shipmentstate.status === 0 ? (
    item.ndr_action_required === 0 ? (
      // ACTION REQUIRED → Buttons
      <div class="btn-group">
        {reattemptLoaderId === item.shipment_id ? (
          <ReactLoading type="spin" height={40} width={60} />
        ) : (
          <a
            class="btn btn-sm btn-success"
            onClick={() => ndrReAttempt(item, 0)}
          >
            Re-Attempt
          </a>
        )}

        {rtoloaderId === item.shipment_id ? (
          <ReactLoading type="spin" height={40} width={60} />
        ) : (
          <>
            {![ "1656377056", "1656013556", "1426513056" ].includes(item.carrier_id) && (
              <a
                class="btn btn-sm ms-2 btn-danger"
                onClick={() => ndrReAttempt(item, 3)}
              >
                RTO
              </a>
            )}
          </>
        )}
      </div>
    ) : (
      // ACTION REQUESTED → Show Action Text
      item.ndr_array?.[0]?.action || ""
    )
  ) : (
    ""
  )}
</div> */}
                          </td>
                          <td>
                            {item.ndr_read_unread === 0 ? (
                              <div className="position-relative d-inline-block">
                                <button
                                  onClick={() => set_update(item)}
                                  className="btn btn-primary"
                                  style={{
                                    cursor: "pointer",
                                    paddingRight: "24px",
                                    position: "relative",
                                  }}
                                >
                                  Take Action
                                </button>

                                <span
                                  className="position-absolute"
                                  style={{
                                    top: "-8px",
                                    right: "-10px",
                                    zIndex: 10, // Make sure it stays on top
                                    fontSize: "20px",
                                    color: "red",
                                  }}
                                >
                                  <i className="fa fa-exclamation-circle"></i>
                                </span>
                              </div>
                            ) : (
                              <a
                                onClick={() => set_update(item)}
                                style={{ cursor: "pointer" }}
                                className="btn btn-primary"
                              >
                                Take Action
                              </a>
                            )}
                          </td>
                          <td>
                            {/* {state.customer_detail?.rto_shield === true && ( */}
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={() => openHistory(item)}
                              data-bs-toggle="modal"
                              data-bs-target="#COMM_HISTORY_MODAL"
                            >
                              View
                            </button>
                            {/* )} */}
                          </td>
                        </tr>
                      ))
                    : ""}
                </tbody>
              </table>
              <div
                class="modal fade"
                id="COMM_HISTORY_MODAL"
                data-bs-backdrop="false"
              >
                <div class="modal-dialog modal-lg">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h4>Communication History</h4>
                      <button
                        class="btn-close"
                        data-bs-dismiss="modal"
                      ></button>
                    </div>

                    <div class="modal-body">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th>Mode</th>
                            <th>Triggered At</th>
                            <th>Response Received</th>
                            <th>Response Received At</th>
                            <th>Action Status</th>
                            <th>Action Message</th>
                          </tr>
                        </thead>

                        <tbody>
                          {communicationHistory.map((item, i) => (
                            <tr key={i}>
                              <td>{item.mode}</td>

                              <td>
                                {item.triggered_at ? (
                                  <>
                                    <Moment format="DD MMM YYYY">
                                      {new Date(item.triggered_at)}
                                    </Moment>
                                    <br />
                                    <Moment format="hh:mm a">
                                      {new Date(item.triggered_at)}
                                    </Moment>
                                  </>
                                ) : (
                                  "--"
                                )}
                              </td>

                              <td>{item.response}</td>

                              <td>
                                {item.response_at ? (
                                  <>
                                    <Moment format="DD MMM YYYY">
                                      {new Date(item.response_at)}
                                    </Moment>
                                    <br />
                                    <Moment format="hh:mm a">
                                      {new Date(item.response_at)}
                                    </Moment>
                                  </>
                                ) : (
                                  "--"
                                )}
                              </td>
                              <td>{item.action_status}</td>
                              <td>{item.action_message}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <TablePagination
                component="div"
                rowsPerPageOptions={[
                  100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
                ]}
                count={otherStates.total_count}
                page={otherStates.page}
                onPageChange={handlePageChange}
                rowsPerPage={otherStates.rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
              {/* <div class="card-footer px-3 border-0 d-flex flex-column flex-lg-row align-items-center justify-content-between">
                       <nav aria-label="Page navigation example">
                           <ul class="pagination mb-0">
                               <li class="page-item">
                                   <a class="page-link" href="#">Previous</a>
                               </li>
                               <li class="page-item">
                                   <a class="page-link" href="#">1</a>
                               </li>
                               <li class="page-item active">
                                   <a class="page-link" href="#">2</a>
                               </li>
                               <li class="page-item">
                                   <a class="page-link" href="#">3</a>
                               </li>
                               <li class="page-item">
                                   <a class="page-link" href="#">4</a>
                               </li>
                               <li class="page-item">
                                   <a class="page-link" href="#">5</a>
                               </li>
                               <li class="page-item">
                                   <a class="page-link" href="#">Next</a>
                               </li>
                           </ul>
                       </nav>
                       <div class="fw-normal small mt-4 mt-lg-0">Showing <b>5</b> out of <b>25</b> entries</div>
                   </div> */}
            </div>
          )}

          <Modal show={ndrmodal} onHide={() => closemodal()} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>
                {" "}
                <h4 class="modal-title">NDR Submit Form</h4>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div class="modal-body">
                <div class="row booking_info_bx">
                  <div className="row">
                    <div className="col-12">
                      <select
                        className="form-select"
                        onChange={(e) => handleNDRchange(e)}
                      >
                        <option>Choose Action</option>
                        <option value="0">Re-Attempt</option>
                        {/* <option value="0">RTO</option> */}
                        {/* <option value="2">Update Address</option>
                                <option value="1">Update Phone</option> */}
                      </select>
                    </div>

                    <div className="row mt-2">
                      {typestate.type == 1 ? (
                        <>
                          <div className="col-6 ">
                            <input
                              className="form-control"
                              placeholder="Enter phone"
                              type="date"
                              name="ndr_date"
                              onChange={(e) => handleNDRchnage(e)}
                            ></input>
                          </div>
                          <div className="col-6 ">
                            <input
                              className="form-control"
                              placeholder="Enter phone"
                              type="number"
                              name="ndr_phone"
                              onChange={(e) => handleNDRchnage(e)}
                            ></input>
                          </div>
                          <div className="col-12 m-2">
                            <input
                              className="form-control"
                              placeholder="Enter Remarks"
                              type="text"
                              name="ndr_remarks"
                              onChange={(e) => handleNDRchnage(e)}
                            ></input>
                          </div>
                        </>
                      ) : typestate.type == 2 ? (
                        <>
                          <div className="col-6 ">
                            <input
                              className="form-control"
                              placeholder="Enter phone"
                              type="date"
                              name="ndr_date"
                              onChange={(e) => handleNDRchnage(e)}
                            ></input>
                          </div>
                          <div className="col-6 ">
                            <input
                              className="form-control"
                              placeholder="Enter address"
                              type="text"
                              name="ndr_address"
                              onChange={(e) => handleNDRchnage(e)}
                            ></input>
                          </div>
                          <div className="col-12 mt-2">
                            <input
                              className="form-control"
                              placeholder="Enter Remarks"
                              type="text"
                              name="ndr_remarks"
                              onChange={(e) => handleNDRchnage(e)}
                            ></input>
                          </div>
                        </>
                      ) : typestate.type == 0 ? (
                        <>
                          <div className="col-12 ">
                            <input
                              className="form-control"
                              placeholder="Enter phone"
                              type="date"
                              name="ndr_date"
                              onChange={(e) => handleNDRchnage(e)}
                            ></input>
                          </div>
                          {/* <div className='col-6 '>
                                <input className='form-control' placeholder='Enter address' type='text'></input>
                              </div> */}
                          <div className="col-12 mt-2">
                            <input
                              className="form-control"
                              placeholder="Enter Remarks"
                              type="text"
                              name="ndr_remarks"
                              onChange={(e) => handleNDRchnage(e)}
                            ></input>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer text-start">
                <button
                  type="button"
                  class="btn btn-primary"
                  onClick={() => ndrReAttempt()}
                >
                  Submit
                </button>
                <button
                  type="button"
                  class="btn btn-outline-danger"
                  onClick={() => closemodal()}
                >
                  I'll Do this later
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </section>
        {openOffdetailcanvas && (
          <section class="order_data">
            <div class="offcanvas offcanvas-end show" id="Shipment_data">
              <div class="offcanvas-header shadow-sm">
                <h4 class="offcanvas-title">
                  Shipment #{bookorder.shipment_id}
                </h4>
                <div class="shipm_tablew">
                  {bookorder.status == 0 ? (
                    <span class="status under_process">
                      <img src="assets/images/spinner.gif" class="img-fluid" />{" "}
                      Under Processing
                    </span>
                  ) : bookorder.status == 10 ? (
                    <span class="status rtrn">
                      {" "}
                      <i class="bi bi-arrow-clockwise"></i> RTO
                    </span>
                  ) : bookorder.status == 19 ? (
                    <span class="status rtrn">
                      {" "}
                      <i class="bi bi-arrow-clockwise"></i> RTO In Transit
                    </span>
                  ) : bookorder.status == 16 ? (
                    <span class="status rtrn">
                      {" "}
                      <i class="bi bi-arrow-clockwise"></i> RTO Delivered
                    </span>
                  ) : bookorder.status == 1 ? (
                    <span class="status pickup_awit">
                      {" "}
                      <i class="bi bi-clock"></i> Pickup Awaited
                    </span>
                  ) : bookorder.status == 2 ? (
                    <span class="status pickedup">
                      {" "}
                      <i class="bi bi-building-fill-up"></i> Pickedup
                    </span>
                  ) : bookorder.status == 3 ? (
                    <span class="status in_transit">
                      {" "}
                      <i class="bi bi-truck"></i> In Transit
                    </span>
                  ) : bookorder.status == 4 ? (
                    <span class="status out_f_deli">
                      {" "}
                      <i class="bi bi-rocket-takeoff"></i> Out for Delivery
                    </span>
                  ) : bookorder.status == 5 ? (
                    <span class="status delivered">
                      {" "}
                      <i class="bi bi-check2-all"></i> Delivered
                    </span>
                  ) : bookorder.status == 6 ? (
                    <span class="status cancelled">
                      {" "}
                      <i class="bi bi-x-square"></i> Cancelled
                    </span>
                  ) : bookorder.status == 7 ? (
                    <span class="status failed">
                      {" "}
                      <i class="bi bi-x-octagon"></i> Failed
                    </span>
                  ) : bookorder.status == 8 ? (
                    <span class="status failed">
                      {" "}
                      <i class="bi bi-x-octagon"></i> NDR
                    </span>
                  ) : bookorder.status == 15 ? (
                    <span class="status failed">
                      {" "}
                      <i class="bi bi-x-octagon"></i> Booked
                    </span>
                  ) : bookorder.status == 16 ? (
                    <span class="status delivered">
                      {" "}
                      <i class="bi bi-check2-all"></i>RTO Delivered
                    </span>
                  ) : bookorder.status == 17 ? (
                    <span class="status failed">
                      {" "}
                      <i class="bi bi-x-octagon"></i>Pickup Failed
                    </span>
                  ) : bookorder.status == 9 ? (
                    <>
                      {" "}
                      <span class="status pickup_sechdls">
                        {" "}
                        <i class="bi bi-calendar"></i> Pickup Scheduled
                      </span>
                      <br />
                      <br />
                      {bookorder.pickup_date != undefined &&
                      bookorder.pickup_date != "" ? (
                        <small>
                          on{" "}
                          {bookorder.pickup_date != undefined
                            ? bookorder.pickup_date
                            : ""}{" "}
                          at{" "}
                          {bookorder.pickup_time != undefined
                            ? bookorder.pickup_time
                            : ""}
                        </small>
                      ) : (
                        ""
                      )}{" "}
                    </>
                  ) : (
                    <span class="badge rounded-pill bg-danger fw-400">
                      Not Available
                    </span>
                  )}
                </div>
                {/* <div class="dropdown text-end">
                                    <button type="button" class="btn btn-outline-primary btn-block dropdown-toggle" data-bs-toggle="dropdown">
                                      Actions
                                    </button>
                                    <ul class="dropdown-menu">
                                      {bookorder.carrier_tracking_number ?


                                        <li>
                                          <a href={`/create_ticket?order_number=${bookorder.carrier_tracking_number}`} class="dropdown-item"> Raise Ticket</a>
                                        </li>
                                        : ""}
                                    </ul>
                                  </div> */}
                <button
                  type="button"
                  class="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  onClick={(e) => closeOffdetailcanvasHandler(e)}
                ></button>
              </div>
              {/* {failedstate.failed != "" ?
                                  <div class="alert alert-danger text-center" role="alert">
                                    Shipment Failed Due to "{failedstate.failed}"
                                  </div> : ""} */}
              <div class="offcanvas-body">
                <section>
                  <div class="">
                    <div class="row mt-3 order_box_cont">
                      <div class="col-12 col-md-8 ">
                        <div class="card border-0 mb-3">
                          <div class="card-body">
                            <div class="d-flex ">
                              <div class="border-end pe-3">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  data-lucide="truck"
                                  class="lucide lucide-truck"
                                >
                                  <path d="M5 18H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v11"></path>
                                  <path d="M14 9h4l4 4v4c0 .6-.4 1-1 1h-2"></path>
                                  <circle cx="7" cy="18" r="2"></circle>
                                  <path d="M15 18H9"></path>
                                  <circle cx="17" cy="18" r="2"></circle>
                                </svg>
                              </div>
                              <div class="ps-3 ">
                                <h6>Shipping Details</h6>
                              </div>
                            </div>
                            <hr />
                            <div class="row">
                              <div class="col-12 col-md-4 mb-2 shipping_carrier_im">
                                <img
                                  src={`https://cdn.thejetpost.in/images/${bookorder.carrier_image}`}
                                  alt=""
                                  class="img-fluid"
                                  title="Fedex Inc."
                                />
                              </div>
                              <div class="col-6 col-md-4 mb-2">
                                <small class="text-muted">Shipment No.</small>
                                <p>
                                  <strong>
                                    <a href="">{bookorder.shipment_id}</a>
                                  </strong>
                                </p>
                              </div>
                              <div class="col-6 col-md-4 mb-2">
                                <small class="text-muted">Order on</small>
                                <p>
                                  <a href="">
                                    {bookorder.shipment_created_date}
                                  </a>
                                </p>
                              </div>
                              <div class="col-6 col-md-4 mb-2">
                                <small class="text-muted">
                                  Shipping Courier
                                </small>
                                <p>
                                  {bookorder.service_provider
                                    ? bookorder.service_provider
                                    : bookorder.carrier_name}
                                </p>
                              </div>
                              {bookorder.carrier_type == "B2B" ? (
                                <div class="col-6 col-md-4 mb-2">
                                  <small class="text-muted">
                                    Shipping Courier LR No.
                                  </small>
                                  <p>
                                    <a href="">
                                      {bookorder.lrnum ? bookorder.lrnum : ""}
                                    </a>
                                  </p>
                                </div>
                              ) : (
                                <div class="col-6 col-md-4 mb-2">
                                  <small class="text-muted">
                                    Shipping Courier AWB No.
                                  </small>
                                  <p>
                                    <a href="">
                                      {bookorder.carrier_tracking_number
                                        ? bookorder.carrier_tracking_number
                                        : ""}
                                    </a>
                                  </p>
                                </div>
                              )}
                              <div class="col-6 col-md-4 mb-2">
                                <small class="text-muted">
                                  Shipping Courier Service
                                </small>
                                <p>{bookorder.service_provider}</p>
                              </div>
                              <div class="col-6 col-md-4 mb-2">
                                <small class="text-muted">Order Type</small>
                                <p>{bookorder.mode}</p>
                              </div>
                              <div class="col-6 col-md-4 mb-2">
                                <small class="text-muted">Shipment Type</small>
                                <p>Forward</p>
                              </div>
                              <div class="col-6 col-md-4 mb-2">
                                <small class="text-muted">Zone</small>
                                <p>{bookorder.zone_name}</p>
                              </div>
                              <div class="col-6 col-md-4 mb-2">
                                <small class="text-muted">
                                  Courier Rule Applied
                                </small>
                                <p>N/A</p>
                              </div>
                              <div class="col-6 col-md-4 mb-2">
                                <small class="text-muted">Payment Mode</small>
                                <p>
                                  {bookorder.payment_mode
                                    ? bookorder.payment_mode.toUpperCase()
                                    : ""}
                                </p>
                              </div>
                              {bookorder.payment_mode == "prepaid" ? (
                                ""
                              ) : (
                                <div class="col-6 col-md-4 mb-2">
                                  <small class="text-muted">Cod Value</small>
                                  <p>{bookorder.cod_amount}</p>
                                </div>
                              )}
                              {/* {bookorder.carrier_type == "B2B" ?
                                                  <>
                                                    <div class="col-6 col-md-4 mb-2"><a class="btn btn-primary" onClick={() => downloadDocket(bookorder)} >Download Docket</a></div>
                                                    {bookorder.status == 5 ?
                                                      <div class="col-6 col-md-4 mb-2"><a class="btn btn-primary" onClick={() => downloadPOD(bookorder)} >Download POD</a></div>
                                                      : ""}
                                                  </>
                                                  : ""} */}
                              {/* <div class="col-12 col-md-4 mb-2 desk_display_none">
                                                  <div class="d-grid">
                                                    <a href="#track_shipment" class="btn btn-outline-secondary btn-block">Track Shipment</a>
                                                  </div>
                                                </div> */}
                            </div>
                          </div>
                        </div>

                        <div class="card border-0  mb-3">
                          <div class="card-body">
                            <div class="d-flex ">
                              <div class="border-end pe-3">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  data-lucide="package-open"
                                  class="lucide lucide-package-open"
                                >
                                  <path d="M20.91 8.84 8.56 2.23a1.93 1.93 0 0 0-1.81 0L3.1 4.13a2.12 2.12 0 0 0-.05 3.69l12.22 6.93a2 2 0 0 0 1.94 0L21 12.51a2.12 2.12 0 0 0-.09-3.67Z"></path>
                                  <path d="m3.09 8.84 12.35-6.61a1.93 1.93 0 0 1 1.81 0l3.65 1.9a2.12 2.12 0 0 1 .1 3.69L8.73 14.75a2 2 0 0 1-1.94 0L3 12.51a2.12 2.12 0 0 1 .09-3.67Z"></path>
                                  <line x1="12" x2="12" y1="22" y2="13"></line>
                                  <path d="M20 13.5v3.37a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13.5"></path>
                                </svg>
                              </div>
                              <div class="ps-3 ">
                                <h6>Package Details</h6>
                              </div>
                            </div>
                            <hr />
                            <div class="row">
                              <div class="col-12 col-md-4 mb-2">
                                <small class="text-muted">
                                  Applicable Weight (in Kg)
                                </small>
                                <p>
                                  {Number(
                                    bookorder?.final_weight ??
                                      bookorder?.total_weight ??
                                      0
                                  ).toFixed(2)}
                                  KG
                                </p>
                              </div>
                              <div class="col-12 col-md-4 mb-2">
                                <small class="text-muted">
                                  Dead Weight (in Kg)
                                </small>
                                <p>{bookorder.dead_weight.toFixed(2)}KG</p>
                              </div>
                              {/* <div class="col-12 col-md-4 mb-2">
                                        <small class="text-muted">Volumetric Weight (in kg)</small>
                                        <p>{bookorder.volumetric_weight}KG</p>
                                      </div> */}
                              <div class="col-12 col-md-4 mb-2">
                                <small class="text-muted">
                                  Dimensions (in cm)
                                </small>
                                <p>
                                  {bookorder.height} x {bookorder.width} x{" "}
                                  {bookorder.length}
                                </p>
                              </div>
                              <div class="col-12 col-md-4 mb-2">
                                <small class="text-muted">
                                  Number of Boxes
                                </small>
                                <p>1</p>
                              </div>
                              {bookorder.b2b_discrepancy_weight ? (
                                <div class="col-12 col-md-4 mb-2">
                                  <strong class="">Chargeable Weight </strong>
                                  <p>
                                    {Number(
                                      bookorder.b2b_discrepancy_weight +
                                        bookorder.total_weight
                                    ).toFixed(2)}{" "}
                                    KG
                                  </p>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                        {bookorder.carrier_type == "B2B" ? (
                          <div class="card border-0 mb-3">
                            <div class="card-body">
                              <div class="d-flex ">
                                <div class="border-end pe-3">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    data-lucide="shopping-basket"
                                    class="lucide lucide-shopping-basket"
                                  >
                                    <path d="m15 11-1 9"></path>
                                    <path d="m19 11-4-7"></path>
                                    <path d="M2 11h20"></path>
                                    <path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4"></path>
                                    <path d="M4.5 15.5h15"></path>
                                    <path d="m5 11 4-7"></path>
                                    <path d="m9 11 1 9"></path>
                                  </svg>
                                </div>
                                <div class="ps-3 ">
                                  <h6>VAS Charges</h6>
                                </div>
                              </div>
                              <hr />
                              <div class="table-responsive ">
                                <table class="table table-light">
                                  <thead>
                                    <tr>
                                      <th>Charge Type</th>
                                      <th>Amount</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {bookorder.vasChargesHistory
                                      ? bookorder.vasChargesHistory.map(
                                          (sub) => (
                                            <tr>
                                              <td>{sub.chargeType}</td>
                                              <td>{sub.amount}</td>
                                            </tr>
                                          )
                                        )
                                      : ""}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}

                        <div class="card border-0 mb-3">
                          <div class="card-body">
                            <div class="d-flex ">
                              <div class="border-end pe-3">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  data-lucide="package"
                                  class="lucide lucide-package"
                                >
                                  <path d="m7.5 4.27 9 5.15"></path>
                                  <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path>
                                  <path d="m3.3 7 8.7 5 8.7-5"></path>
                                  <path d="M12 22V12"></path>
                                </svg>
                              </div>
                              <div class="ps-3 ">
                                <h6>Shipment Details</h6>
                              </div>
                            </div>
                            <hr />
                            <div class="row">
                              <div class="col-12 col-md">
                                <h6>Ship From:</h6>
                                <small class="text-muted">Sender Name:</small>
                                <p>{bookorder.sender[0].name}</p>
                                <small class="text-muted">
                                  Sender Address:
                                </small>
                                <p>
                                  {bookorder.sender[0].address},
                                  {bookorder.sender[0].city},{" "}
                                  {bookorder.sender[0].state}{" "}
                                  {bookorder.sender[0].pincode}
                                </p>
                                <small class="text-muted">Sender Email:</small>
                                <p>{bookorder.sender[0].email}</p>
                                <small class="text-muted">Sender Mobile:</small>
                                <p>{bookorder.sender[0].mobile}</p>
                              </div>
                              <div class="col-12 col-md">
                                <h6>Ship To:</h6>
                                <small class="text-muted">Receiver Name:</small>
                                <p>{bookorder.receiver[0].name}</p>
                                <small class="text-muted">
                                  Receiver Address:
                                </small>
                                <p>
                                  {bookorder.receiver[0].address},
                                  {bookorder.receiver[0].city},{" "}
                                  {bookorder.receiver[0].state}{" "}
                                  {bookorder.receiver[0].pincode}
                                </p>
                                <small class="text-muted">
                                  Receiver Email:
                                </small>
                                <p>{bookorder.receiver[0].email}</p>
                                <small class="text-muted">
                                  Receiver Mobile:
                                </small>
                                <p>{bookorder.receiver[0].mobile}</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="card border-0  mb-3">
                          <div class="card-body">
                            <div class="d-flex ">
                              <div class="border-end pe-3">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  data-lucide="dollar-sign"
                                  class="lucide lucide-dollar-sign"
                                >
                                  <line x1="12" x2="12" y1="2" y2="22"></line>
                                  <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                                </svg>
                              </div>
                              <div class="ps-3 ">
                                <h6>Payment Details</h6>
                              </div>
                            </div>
                            <hr />
                            <div class="row">
                              <div class="col-12 col-md-4 mb-2">
                                <small class="text-muted">
                                  Total Paid Amount
                                </small>
                                <p>
                                  ₹{" "}
                                  {bookorder?.final_amount ||
                                    bookorder?.total_amount ||
                                    ""}
                                </p>
                              </div>
                              <div class="col-12 col-md-4 mb-2">
                                <small class="text-muted">Payment Mode</small>
                                <p>Wallet</p>
                              </div>
                              {/* <div class="col-12 col-md-4 mb-2">
                                                    <small class="text-muted">Transaction ID</small>
                                                    <p><a href="">3456789876</a></p>
                                                </div> */}
                            </div>
                          </div>
                        </div>
                        {bookorder.carrier_type == "B2B" ? (
                          <div class="card border-0 mb-3">
                            <div class="card-body">
                              <div class="d-flex ">
                                <div class="border-end pe-3">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    data-lucide="shopping-basket"
                                    class="lucide lucide-shopping-basket"
                                  >
                                    <path d="m15 11-1 9"></path>
                                    <path d="m19 11-4-7"></path>
                                    <path d="M2 11h20"></path>
                                    <path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4"></path>
                                    <path d="M4.5 15.5h15"></path>
                                    <path d="m5 11 4-7"></path>
                                    <path d="m9 11 1 9"></path>
                                  </svg>
                                </div>
                                <div class="ps-3 ">
                                  <h6>Boxes Details</h6>
                                </div>
                              </div>
                              <hr />
                              <div class="table-responsive ">
                                <table class="table table-light">
                                  <thead>
                                    <tr>
                                      <th>Length</th>
                                      <th>Width</th>
                                      <th>Height</th>
                                      <th>Weight</th>
                                      <th>Quantity</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {bookorder.boxes.map((sub) => (
                                      <tr>
                                        <td>{sub.box_length}</td>
                                        <td>{sub.box_width}</td>
                                        <td>{sub.box_height}</td>
                                        <td>{sub.box_weight}</td>
                                        <td>{sub.quantity}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}

                        {bookorder.carrier_type == "B2B" ? (
                          <div class="card border-0 mb-3">
                            <div class="card-body">
                              <div class="d-flex ">
                                <div class="border-end pe-3">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    data-lucide="shopping-basket"
                                    class="lucide lucide-shopping-basket"
                                  >
                                    <path d="m15 11-1 9"></path>
                                    <path d="m19 11-4-7"></path>
                                    <path d="M2 11h20"></path>
                                    <path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4"></path>
                                    <path d="M4.5 15.5h15"></path>
                                    <path d="m5 11 4-7"></path>
                                    <path d="m9 11 1 9"></path>
                                  </svg>
                                </div>
                                <div class="ps-3 ">
                                  <h6>Invoices Details</h6>
                                </div>
                              </div>
                              <hr />
                              <div class="table-responsive ">
                                <table class="table table-light">
                                  <thead>
                                    <tr>
                                      <th>Invoice Number</th>
                                      <th>Invoice Amount</th>
                                      <th>Invoice EBN</th>
                                      {/* <th>Total</th> */}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {bookorder.invoices.map((sub) => (
                                      <tr>
                                        <td>{sub.invoice_number}</td>
                                        <td>{sub.invoice_amount}</td>
                                        <td>{sub.invoice_ebn}</td>
                                        {/* <td> {bookorder.invoices.reduce((total, sub) => total + parseFloat(sub.invoice_amount), 0).toFixed(2)}</td> */}
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      <div class="col-12 col-md-4">
                        {/* <section class="bg-white p-3 mb-3">
                        <p>
                            Jaipur <i class="bi bi-arrow-right"></i> Delhi
                            <span class="text-end"><small class="text-muted">Location last updated on 3 May 2022 09:38</small></span>
                        </p>
        
                        
                        <p>Delivery ETA - <span class="text-muted">03-02-2022 @ 23:29</span></p>
                    </section> */}
                        <div class="card border-0 shadow-sm tracking_xb">
                          <div class="card-body">
                            <div class="d-flex ">
                              <div class="border-end pe-3">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  data-lucide="package-search"
                                  class="lucide lucide-package-search"
                                >
                                  <path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"></path>
                                  <path d="m7.5 4.27 9 5.15"></path>
                                  <polyline points="3.29 7 12 12 20.71 7"></polyline>
                                  <line x1="12" x2="12" y1="22" y2="12"></line>
                                  <circle cx="18.5" cy="15.5" r="2.5"></circle>
                                  <path d="M20.27 17.27 22 19"></path>
                                </svg>
                              </div>
                              <div class="ps-3 ">
                                <h6>Tracking Info</h6>
                              </div>
                            </div>
                            <hr />
                            {trackingstate.track != "" &&
                            stateship.shipmentDetail != "" ? (
                              <div class="progress-container  position-relative">
                                {trackingstate.isLoading == false ? (
                                  trackingstate.track.history.length > 0 ? (
                                    trackingstate.track.history.map((sub) => (
                                      <div class="step-container">
                                        <div class="step active">
                                          <i class="bi bi-check-circle-fill"></i>
                                        </div>
                                        <div class="progress"></div>
                                        <div class="step-info">
                                          <h4>{sub.message} </h4>
                                          <p>{sub.location}</p>
                                          {bookorder.carrier_id ==
                                          "1744278194" ? (
                                            <p>{sub.time}</p>
                                          ) : bookorder.carrier_id ==
                                            "2433170006" ? (
                                            <p>
                                              <Moment format="MMM DD YYYY hh:mm:ss a">
                                                {sub.time}
                                              </Moment>
                                            </p>
                                          ) : (
                                            <p>
                                              {" "}
                                              <Moment format="MMM DD YYYY hh:mm:ss a">
                                                {sub.time}
                                              </Moment>
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    ))
                                  ) : (
                                    "No Data Available"
                                  )
                                ) : (
                                  <ReactLoading
                                    type="bubbles"
                                    color="#0d6efd"
                                    style={{
                                      position: "absolute",
                                      right: "45%",
                                      height: "20px",
                                      width: "10%",
                                    }}
                                  />
                                )}
                              </div>
                            ) : (
                              "No Data Available"
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
            <div className="offcanvas-backdrop fade show"></div>
          </section>
        )}
      </section>
    </div>
  );
};

export default Ndr_shipments;
